/**
 * @ Author: Housefolios
 * @ Create Time: 2021-12-16 11:36:56
 * @ Modified by: David Helmick
 * @ Modified time: 2025-12-17 17:01:05
 * @ Description: Build to Rent Strategy Analysis page
 */

import React, { useEffect, Suspense, lazy, useState } from 'react'
import {
  strategyBadgeIconSx,
  strategyBlockSpacerSx,
  strategyCardBodyPadSx,
  strategyCardTitleSx,
  strategyCenterTextSx,
  strategyCircleGreenAvatarSx,
  strategyFieldLabelSx,
  strategyFlexCenterOnlySx,
  strategyFlexCenterRowSx,
  strategyFlexCenterSx,
  strategyFlexGrowSx,
  strategyFlexPadSx,
  strategyFooterNoteSx,
  strategyFullHeight100Sx,
  strategyFullWidthHiddenSx,
  strategyIconGap20Style,
  strategyIconGapStyle,
  strategyMarginBottom10Sx,
  strategyMaxHeight440Sx,
  strategyMetricDotBlueSx,
  strategyMetricDotGreenSx,
  strategyMetricDotRedSx,
  strategyMetricGrayBgSx,
  strategyMetricRowFlexSx,
  strategyMetricRowSx,
  strategyMutedDividerSx,
  strategyMutedTextSx,
  strategyNavyBgSx,
  calcDialogPaperSx,
  strategyPadVert15Sx,
  strategySectionLabelSx,
  strategySubtitleCenterSx,
  strategyTableRowLastSx,
  strategyTableRowSx,
  strategyTooltipLinkSx,
  strategyUppercaseMetaSx,
  strategyWhiteTextSx,
} from '@/housefolios-components/PropertyContainer/CenterPage/Common/strategyDashboardSx'
import { useQuery } from '@apollo/client/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CountUp from '@/utils/SafeCountUp'
import clsx from 'clsx'
// Centralized lodash imports - much cleaner!
import {
  map,
  sum,
  round,
  every,
  isEmpty,
  filter,
  includes,
  difference,
  sortBy,
  find,
  findIndex,
  get,
  merge,
  cloneDeep,
  zip,
  concat,
  slice,
  isNil,
  isEqual,
  replace,
  head,
  last,
  compact,
  uniq} from '@/utils/lodash'
import { useLocation } from 'react-router'

const Chart = lazy(() => import('@/utils/SafeApexChart'))

import {
  Grid, Box, Button, Card, CardActions, CardContent, CardHeader, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormGroup, FormControlLabel,  List, ListItem, ListItemButton, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, Drawer, IconButton, FormControl, Collapse } from '@mui/material'

import dark365Square from '@/assets/images/365_square_Dark.png'

import ContactAgent from '../../../Marketplace/ContactAgent'

import { UPDATE_PROPERTY } from '@/housefolios-components/PropertyContainer/mutations'
import { GET_PROPERTY } from '@/housefolios-components/PropertyContainer/queries'
import { useMutation } from '@apollo/client/react'
import { Close } from '@mui/icons-material'
import { UPDATE_ORGANIZATION } from '@/housefolios-components/OrganizationSettings/mutations'
import { DEFAULT_PREFERENCES } from '@/housefolios-components/OrganizationSettings/OrganizationPreferences'
import withSession from '@/housefolios-components/Session/withSession'
import { GET_ME } from '@/housefolios-components/Session/queries'
import { enqueueSnackbar } from 'notistack'
import Add from '@mui/icons-material/Add'
import { GET_CARDS } from '@/housefolios-components/Properties/queries'

import { assumptionsOptions } from '../../../AssumptionsSettings/Accordion'
import { DEFAULT_ANALYTICS } from '@/housefolios-components/Property/fragments'
import useAmortizationDialog from '@/hooks/useAmortizationDialog'
import AmortizationDialog from '@/housefolios-components/Dialogs/Amortization'
import { loanBalance } from '@/utils/loanBalance'
import {
  BuildToRentCashPositioningTour,
  BuildToRentComparablePropertiesTour,
  BuildToRentConstructionLoanTour,
  BuildToRentDispositionExpensesTour,
  BuildToRentEndBuyerFinancingTour,
  BuildToRentFinancingTour,
  BuildToRentGrossMonthlyIncomeTour,
  BuildToRentMezzanineLoanTour,
  BuildToRentMonthlyCashflowTour,
  BuildToRentMonthlyExpensesTour,
  BuildToRentStrategyTour,
  BuildToRentTargetsTour,
  BuildToRentValueOverTimeTour} from './tours'

import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'
import {
  ComparablePropertiesCard,
  DeactiveCard,
  StrategyCard,
  StrategyPageBase,
  TargetsCard,
  calculateCompData,
  createChartColors,
  createCurrencyFormat,
  createCashflowChartOptions,
  createDonutChartOptions,
  createPercentageFormat,
  createStrategySummary,
  useStrategyPage} from '../Common'

function CenterPageBuildToRent(props) {
  const {
    property,
    analysisInput,
    assumptionsInput,
    renderInputFields} = props

  const {
    openAmortization,
    handleOpenAmortization,
    handleCloseAmortization} = useAmortizationDialog()

  const {
    modal1,
    maxOfferDescription,
    openStrategyTour,
    openTargetsTour,
    openComparablePropertiesTour,
    toggle1,
    toggle1Close,
    toggleMaxOffer,
    toggleStrategyTour,
    toggleTargetsTour,
    toggleComparablePropertiesTour,
    closeStrategyTour,
    closeTargetsTour,
    closeComparablePropertiesTour} = useStrategyPage({ strategyName: 'Build to Rent'  })
  const [
    openBuildToRentMonthlyCashflowTour,
    setOpenBuildToRentMonthlyCashflowTour,
  ] = useState(false)
  const [
    openBuildToRentGrossMonthlyIncomeTour,
    setOpenBuildToRentGrossMonthlyIncomeTour,
  ] = useState(false)
  const [
    openBuildToRentMonthlyExpensesTour,
    setOpenBuildToRentMonthlyExpensesTour,
  ] = useState(false)
  const [
    openBuildToRentFinancingTour,
    setOpenBuildToRentFinancingTour,
  ] = useState(false)
  const [
    openBuildToRentConstructionLoanTour,
    setOpenBuildToRentConstructionLoanTour,
  ] = useState(false)
  const [
    openBuildToRentMezzanineLoanTour,
    setOpenBuildToRentMezzanineLoanTour,
  ] = useState(false)
  const [
    openBuildToRentEndBuyerFinancingTour,
    setOpenBuildToRentEndBuyerFinancingTour,
  ] = useState(false)
  const [
    openBuildToRentValueOverTimeTour,
    setOpenBuildToRentValueOverTimeTour,
  ] = useState(false)
  const [
    openBuildToRentCashPositioningTour,
    setOpenBuildToRentCashPositioningTour,
  ] = useState(false)
  const [
    openBuildToRentDispositionExpensesTour,
    setOpenBuildToRentDispositionExpensesTour,
  ] = useState(false)

  let results = useQuery(GET_CARDS, {
    variables: { view: 'BuildToRent' }})
  let data = results.data || {}
  const cardsLoading = results.loading
  const cardsError = results.error
  let { cards = [] } = data

  // const { activeOrg = {} } = props.session.me || {}
  const activeOrg = property?.portfolio?.organization
  const { acquisition = {}, assumptions = {} } = property
  const { analytics = DEFAULT_ANALYTICS, analysis = {} } = acquisition
  let amortizationData = loanBalance({
    financeAmount: analytics.B2R.lotLoanAmount,
    netOperatingIncome: analytics.B2R.netOperatingIncomeB2R,
    mortgagePayment: analytics.B2R.lotMortgage,
    monthlyRate: assumptions.rate / 100 / 12,
    holdingPeriod: assumptions.rentalHoldingPeriodB2R * 12,
    payDownAccelerator: assumptions.payDownAccelerator,
    payDownGrowth: assumptions.payDownGrowth,
    growthRateIncome: assumptions.growthRateIncome,
    growthRateExpense: assumptions.growthRateIncome,
  })

  // const [openAmortization, setOpenAmortization] = useState(false)
  // const handleOpenAmortization = () => {
  //   setOpenAmortization(true)
  // }
  // const handleCloseAmortization = () => {
  //   setOpenAmortization(false)
  // }

  const tableHeaders = [
    { title: '', name: 'Date', align: 'left' },
    { title: '', name: 'Interest', align: 'center' },
    { title: '', name: 'Principal', align: 'center' },
    { title: '', name: 'Additional Principal', align: 'center' },
    { title: '', name: 'Balance', align: 'center' },
  ]

  const dollarPercentAmount = (ofAmount, value, peramt) => {
    let typeData = []
    let dollarAmount = 0
    let percentAmount = 0

    if (peramt === '%') {
      dollarAmount = (value / 100) * ofAmount
      percentAmount = value
    } else if (peramt === '$') {
      dollarAmount = value
      if (ofAmount !== 0)
        percentAmount = ((value / ofAmount) * 100).toFixed(2)
    }

    typeData.push({
      dollar: dollarAmount,
      percent: percentAmount,
    })

    return typeData
  }

  let IRRDataFirst = {}
  let IRRData = []
  let IRRDataLast = {}

  const IRRTable = (args) => {
    let {
      valueAppreciation, //arv ? arv : sellPrice
      grossAnnualRent,
      annualExpenses,
      mp_monthly,
      rentalHoldingPeriod,
      growthRateIncomeMonthly,
      growthRateExpenseMonthly,
      rehabPeriod,
      totalOutOfPocket,
      homePriceAppreciation,
      listPriceToSalePriceRatio,
      salesCommission,
      salesCommissionType,
      sellingClosingCostDollar,
      loanBalanceAtHoldingPeriod,
      dispositionFee,
      dispositionFeeType} = args

    let cashFlowTotal = 0
    let arrInHoldingPeriodMonthly = grossAnnualRent / 12
    let expensesInHoldingPeriodMonthly = annualExpenses / 12
    let cashFlowInHoldingPeriodMonthly = 0
    let salePrice = 0

    let month
    let year
    let monthYear

    const today = new Date()

    const IRRDate = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      1,
    )

    for (let index = 1; index < rentalHoldingPeriod + 1; index++) {
      if (index > 1) {
        arrInHoldingPeriodMonthly *= 1 + growthRateIncomeMonthly
        expensesInHoldingPeriodMonthly *= 1 + growthRateExpenseMonthly
      }
      let income =
        index > rehabPeriod + 1 ? arrInHoldingPeriodMonthly : 0
      cashFlowInHoldingPeriodMonthly =
        mp_monthly < 0
          ? income - expensesInHoldingPeriodMonthly
          : income - expensesInHoldingPeriodMonthly - mp_monthly
      if (index === 1) {
        month = IRRDate.toLocaleString('default', { month: 'long'  })
        year = IRRDate.getFullYear().toString()
        monthYear = month + ' ' + year
        IRRDataFirst = {
          totalOutOfPocket,
          monthYear}
      } else {
        valueAppreciation *= 1 + homePriceAppreciation / 12 / 100
        IRRDate.setMonth(IRRDate.getMonth() + 1)
        let month = IRRDate.toLocaleString('default', {
          month: 'long'})
        let year = IRRDate.getFullYear().toString()
        monthYear = month + ' ' + year
        if (index < rentalHoldingPeriod) {
          IRRData.push({
            flow: cashFlowInHoldingPeriodMonthly,
            income,
            expenses: expensesInHoldingPeriodMonthly,
            mortgage: mp_monthly,
            monthYear,
            })
        } else if (index === rentalHoldingPeriod) {
          let cashFlowInHoldingPeriod = cashFlowTotal

          salePrice =
            (listPriceToSalePriceRatio / 100) * valueAppreciation
          let salesCommissionTotal =
            salesCommissionType === '$'
              ? salesCommission
              : (salesCommission / 100) * salePrice

          const dispositionFeeIRRDP = dollarPercentAmount(
            salePrice,
            dispositionFee,
            dispositionFeeType,
          )

          const lastMonthCashFlow =
            salePrice -
            loanBalanceAtHoldingPeriod -
            salesCommissionTotal -
            sellingClosingCostDollar -
            dispositionFeeIRRDP[0].dollar +
            cashFlowInHoldingPeriodMonthly

          IRRDataLast = {
            lastMonthCashFlow,
            monthYear}
        }
      }
    }
  }

  IRRTable({
    valueAppreciation: analytics.B2R.arvTotalB2R
      ? analytics.B2R.arvTotalB2R
      : analysis.resellPriceB2R,
    grossAnnualRent: sum(analytics.grossAnnualRent),
    annualExpenses: analytics.B2R.annualExpensesB2R,
    mp_monthly:
      analytics.B2R.lotMortgage +
      analytics.B2R.constructionMortgage +
      sum(analytics.B2R.mezzanineMortgage),
    rentalHoldingPeriod: assumptions.rentalHoldingPeriodB2R,
    growthRateIncomeMonthly: assumptions.growthRateIncome / 12 / 100,
    growthRateExpenseMonthly:
      assumptions.growthRateExpense / 12 / 100,
    rehabPeriod: -1,
    totalOutOfPocket: analytics.B2R.totalOutOfPocketB2R,
    homePriceAppreciation: assumptions.homePriceAppreciation,
    listPriceToSalePriceRatio: assumptions.listPriceToSalePriceRatio,
    salesCommission: assumptions.salesCommissionB2R,
    salesCommissionType: assumptions.salesCommissionB2RType,
    sellingClosingCostDollar:
      analytics.B2R.sellingClosingCostDollarB2R,
    loanBalanceAtHoldingPeriod:
      analytics.B2R.lotLoanBalanceAtHoldingPeriod +
      analytics.B2R.constructionLoanBalanceAtHoldingPeriod +
      sum(analytics.B2R.mezzanineLoanBalanceAtHoldingPeriod),
    dispositionFee: assumptions.dispositionFeeB2R,
    dispositionFeeType: assumptions.dispositionFeeB2RType})

  const IRRTableFirstHeaders = [
    { title: '', name: 'Date', align: 'left' },
    { title: '', name: 'Total Out of Pocket', align: 'center' },
  ]

  const IRRTableHeaders = [
    { title: '', name: 'Date', align: 'left' },
    { title: '', name: 'Income', align: 'center' },
    { title: '', name: 'Expenses', align: 'center' },
    { title: '', name: 'Mortgage', align: 'center' },
    { title: '', name: 'Cashflow', align: 'center' },
  ]

  const IRRTableLastHeaders = [
    { title: '', name: 'Date', align: 'left' },
    { title: '', name: 'Last Month Cashflow', align: 'center' },
  ]

  const [activeTab, setActiveTab] = useState(0)

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const [openConfirmLender, setOpenConfirmLender] = useState(false)

  const toggleOpenConfirmLender = () => {
    setOpenConfirmLender(!openConfirmLender)
  }

  useEffect(() => {
    if (
      analysisInput.lotLender !== analysis.lotLender ||
      analysisInput.constructionLender !==
        analysis.constructionLender ||
      (!isEqual(
        analysisInput.mezzanineLender,
        analysis.mezzanineLender,
      ) &&
        (analysisInput.mezzanineLender || ['']).length ===
          (analysis.mezzanineLender || ['']).length)
    )
      toggleOpenConfirmLender()
  }, [
    analysisInput.lotLender,
    analysisInput.constructionLender,
    analysisInput.mezzanineLender,
  ])

  const currencyFormat = createCurrencyFormat()
  const pieColors = createChartColors()

  const currencyFormat2 = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 })

  const percentageFormat = createPercentageFormat()

  const [openManagementCompanies, setOpenManagementCompanies] =
    useState(false)
  const handleOpenManagementCompanies = () => {
    setOpenManagementCompanies(true)
  }
  const handleCloseManagementCompanies = () => {
    setOpenManagementCompanies(false)
  }

  //const [loader, setLoader] = useState(false)

  const [accordion, setAccordion] = useState(-1)

  const toggleAccordion = (index) => {
    if (index === accordion) setAccordion(-1)
    else setAccordion(index)
  }

  const [getFinancing, setGetFinancing] = useState(null)

  const toggleGetFinancing = (name) => {
    setGetFinancing(name)
  }

  const toggleGetFinancingClose = () => {
    setGetFinancing(null)
  }

  const cashFlowAccumulationCalculate = (args) => {
    const {
      accelerator,
      term,
      rentAmount,
      vacancy,
      propertyTaxes,
      homeInsurance,
      monthlyHOA,
      propertyMgmtPercent,
      maintenance,
      utilities,
      annualRevenueIncrease,
      annualOperatingExpenseIncrease,
      //added so that cash flow is with Financing
      mortgagePayment} = args

    let pdAccelerator = accelerator / 100
    let rent = rentAmount
    let rentIncrease = map(rent, (value) => 0)
    let vac = map(
      zip(rentAmount, vacancy),
      ([rentAmount, vacancy]) => rentAmount * vacancy,
    )
    let revenue = 0
    let propTax = propertyTaxes
    let propTaxIncrease = 0
    let insurance = homeInsurance
    let insuranceIncrease = 0
    let hoa = monthlyHOA
    let hoaIncrease = 0
    let propMgmt = sum(rentAmount) * propertyMgmtPercent
    let main = sum(rentAmount) * maintenance
    let mainIncrease = 0
    let uti = utilities
    let utiIncrease = 0
    let expenses = 0
    let cashFlow = 0
    let cfyear = []
    //added so that cash flow is with Financing
    let mortgage = 0

    for (let index = 1; index < term; index++) {
      if (index > 1 && index < 12) {
        rent = map(
          zip(rent, rentAmount),
          ([rent, rentAmount]) => rent + rentAmount,
        )
        propTax += propertyTaxes
        insurance += homeInsurance
        hoa += monthlyHOA
        //added so that cash flow is with Financing
        mortgage += mortgagePayment
      } else if (index % 12 === 0) {
        if (index / 12 === 1) {
          rent = map(
            zip(rent, rentAmount),
            ([rent, rentAmount]) => rent + rentAmount,
          )
          vac = map(
            zip(rent, vacancy),
            ([rent, vacancy]) => rent * vacancy,
          )
          revenue = sum(rent) - sum(vac)

          propTax += propertyTaxes
          insurance += homeInsurance
          hoa += monthlyHOA
          propMgmt = revenue * propertyMgmtPercent
          main = sum(rent) * maintenance
          expenses = propTax + insurance + hoa + propMgmt + main + uti

          //added so that cash flow is with Financing
          mortgage += mortgagePayment

          cashFlow = revenue - expenses - mortgage
          cashFlow = cashFlow - pdAccelerator * cashFlow

          cfyear.push({
            year: index / 12,
            cashFlow: cashFlow})

          rentIncrease = map(
            rentAmount,
            (rentAmount) =>
              rentAmount + rentAmount * annualRevenueIncrease,
          )
          propTaxIncrease =
            propTax * (1 + annualOperatingExpenseIncrease)
          insuranceIncrease =
            insurance * (1 + annualOperatingExpenseIncrease)
          hoaIncrease = hoa * (1 + annualOperatingExpenseIncrease)
          mainIncrease = main * (1 + annualOperatingExpenseIncrease)
          utiIncrease = uti * (1 + annualOperatingExpenseIncrease)
        } else {
          rent = map(
            zip(rent, rentIncrease),
            ([rent, rentIncrease]) => rent + rentIncrease,
          )
          vac = map(
            zip(rent, vacancy),
            ([rent, vacancy]) => rent * vacancy,
          )
          revenue = sum(rent) - sum(vac)

          propTax += propTaxIncrease
          insurance += insuranceIncrease
          hoa += hoaIncrease
          propMgmt = revenue * propertyMgmtPercent
          main += mainIncrease
          uti += utiIncrease
          expenses = propTax + insurance + hoa + propMgmt + main + uti

          //added so that cash flow is with Financing
          mortgage += mortgagePayment

          cashFlow = revenue - expenses - mortgage
          cashFlow = cashFlow - pdAccelerator * cashFlow

          cfyear.push({
            year: index / 12,
            cashFlow: cashFlow})

          rentIncrease = map(
            rentIncrease,
            (rentIncrease) =>
              rentIncrease + rentIncrease * annualRevenueIncrease,
          )
          propTaxIncrease =
            propTaxIncrease * (1 + annualOperatingExpenseIncrease)
          insuranceIncrease =
            insuranceIncrease * (1 + annualOperatingExpenseIncrease)
          hoaIncrease =
            hoaIncrease * (1 + annualOperatingExpenseIncrease)
          mainIncrease =
            mainIncrease * (1 + annualOperatingExpenseIncrease)
          utiIncrease =
            utiIncrease * (1 + annualOperatingExpenseIncrease)
        }
      } else {
        rent = map(
          zip(rent, rentIncrease),
          ([rent, rentIncrease]) => rent + rentIncrease,
        )
        //added so that cash flow is with Financing
        mortgage += mortgagePayment
      }
    }

    return cfyear
  }

  const cashFlowAccumulation = cashFlowAccumulationCalculate({
    accelerator: assumptions.payDownAccelerator || 0,
    term:
      assumptions.termTurnkeyType === 'Years'
        ? (assumptions.termTurnkey || 0) * 12 + 1
        : (assumptions.termTurnkey || 0) + 1,
    rentAmount: analysis.rent || [0],
    vacancy: assumptions.vacancy
      ? map(assumptions.vacancy, (vacancy) => vacancy / 100)
      : [0],
    propertyTaxes: (analysis.propertyTaxes || 0) / 12,
    homeInsurance:
      (analytics.turnkey.propertyInsuranceDollarTurnkey || 0) / 12,
    monthlyHOA: analytics.B2R.hoaTotal / 12 || 0,
    propertyMgmtPercent:
      (assumptions.propertyManagementTurnkey || 0) / 100,
    maintenance: (assumptions.maintenanceTurnkey || 0) / 100,
    utilities: analytics.turnkey.utilitiesTypeDollarTurnkey || 0,
    annualRevenueIncrease: (assumptions.growthRateIncome || 0) / 100,
    annualOperatingExpenseIncrease:
      (assumptions.growthRateExpense || 0) / 100,
    mortgagePayment: analytics.turnkey.mortgageTurnkey || 0})

  let cashFlow1 = 0
  let cashFlow3 = 0
  let cashFlow5 = 0
  let cashFlow10 = 0

  for (let key in cashFlowAccumulation) {
    const tmp = cashFlowAccumulation[key]
    if (tmp.year === 1) cashFlow1 = tmp.cashFlow
    if (tmp.year === 3) cashFlow3 = tmp.cashFlow
    if (tmp.year === 5) cashFlow5 = tmp.cashFlow
    if (tmp.year === 10) cashFlow10 = tmp.cashFlow
  }

  const dispositionFields = [
    {
      type: 'dollar',
      name: 'resellPriceB2R',
      label: 'Resale Price',
      value:
        analysisInput.resellPriceB2R === null
          ? ''
          : analysisInput.resellPriceB2R.toString(),
      xs: 12,
      lg: 6,
      tooltipField:
        'The price you will resell the property for once the rehab is completed.',
      dataTour: 'dispositionExpenses-step-1'},
    {
      type: 'dropdown',
      name: 'sellerClosingCostB2R',
      label: 'Seller Closing Cost',
      value: assumptionsInput.sellerClosingCostB2R,
      adornmentToggle: assumptionsInput.sellerClosingCostB2RType,
      adornment: assumptionsInput.sellerClosingCostB2RType,
      adornmentName: 'sellerClosingCostB2RType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Closing Costs Paid by the Seller. Expressed as a dollar amount or percentage of the resale price',
      dataTour: 'dispositionExpenses-step-2'},
    {
      type: 'dropdown',
      name: 'financingFeeB2R',
      label: 'Financing Fee',
      value: assumptionsInput.financingFeeB2R,
      adornment: assumptionsInput.financingFeeB2RType,
      adornmentToggle: assumptionsInput.financingFeeB2RType,
      adornmentName: 'financingFeeB2RType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Advanced Fee - A fee that the real estate professional charges for securing financing on the property. Expressed as a percentage of the loan amount.'},
    {
      type: 'dollar',
      name: 'ownerReservesB2R',
      label: '1x Owner Reserve',
      value: assumptionsInput.ownerReservesB2R,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A single contribution of money paid shortly after closing to keep in the bank to be used for large future expenses (capex items, etc.)'},
    {
      type: 'dropdown',
      name: 'salesCommissionB2R',
      label: 'Sales Commission',
      value: assumptionsInput.salesCommissionB2R,
      adornmentToggle: assumptionsInput.salesCommissionB2RType,
      adornment: assumptionsInput.salesCommissionB2RType,
      adornmentName: 'salesCommissionB2RType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Sales Commission on the Future Sale of Property. Expressed as a dollar amount or percentage of resale price.',
      dataTour: 'dispositionExpenses-step-3'},
    {
      type: 'dropdown',
      name: 'dispositionFeeB2R',
      label: 'Disposition Fee',
      value: assumptionsInput.dispositionFeeB2R,
      adornmentToggle: assumptionsInput.dispositionFeeB2RType,
      adornment: assumptionsInput.dispositionFeeB2RType,
      adornmentName: 'dispositionFeeB2RType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Advanced Fee - Additional marketing fee on top of sales commission. Expressed as a dollar amount or percentage of resale price.',
      dataTour: 'dispositionExpenses-step-4'},
    {
      type: 'percentage',
      name: 'homePriceAppreciation',
      label: 'Home Price Appreciation',
      value: assumptionsInput.homePriceAppreciation,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The % of Appreciation in Total Dollar Value that the Home has gained or lost each year. Expressed as a percentage of ARV (after repair value). If your holding period is less than 12 months, this field will have no effect.',
      dataTour: 'dispositionExpenses-step-5'},
    {
      type: 'percentage',
      name: 'growthRateExpense',
      label: 'Expense Growth Rate',
      value: assumptionsInput.growthRateExpense,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The % increase in property expenses per year. Expressed as a percentage of gross rental income. If your holding period is less than 12 months, this field will have no effect.',
      dataTour: 'dispositionExpenses-step-6'},
    {
      type: 'dollar',
      name: 'loanBalanceAtHoldingPeriod',
      label: 'Loan Balance at Resale',
      value:
        analytics.B2R.lotLoanBalanceAtHoldingPeriod +
          analytics.B2R.constructionLoanBalanceAtHoldingPeriod +
          sum(analytics.B2R.mezzanineLoanBalanceAtHoldingPeriod) ===
        null
          ? ''
          : (
              analytics.B2R.lotLoanBalanceAtHoldingPeriod +
              analytics.B2R.constructionLoanBalanceAtHoldingPeriod +
              sum(analytics.B2R.mezzanineLoanBalanceAtHoldingPeriod)
            ).toString(),
      xs: 12,
      lg: 6,
      disabled: true,
      tooltipField:
        'This field is not editable. The remaining loan amount at the end of your flip holding period.',
      dataTour: 'dispositionExpenses-step-7'},
  ]

  const dispositionChartOptions = createDonutChartOptions(
    currencyFormat,
    [
      'Seller Closing Cost',
      'Sales Commission',
      'Disposition Fee',
      'Loan Balance at Resale',
    ],
    pieColors,
  )
  const dispositionChartSeries = [
    round(analytics.B2R.sellingClosingCostDollarB2R, 2) || 0.0001,
    round(analytics.B2R.salesCommissionTotalB2R, 2) || 0,
    round(analytics.B2R.dispositionFeeDollarB2R, 2) || 0,
    round(
      analytics.B2R.lotLoanBalanceAtHoldingPeriod +
        analytics.B2R.constructionLoanBalanceAtHoldingPeriod +
        sum(analytics.B2R.mezzanineLoanBalanceAtHoldingPeriod),
      2,
    ) || 0,
  ]

  const options = {
    dataLabels: {
      enabled: false},
    xaxis: {
      categories: ['1 yr', '3 yrs', '5 yrs', '10 yrs']},
    yaxis: {
      labels: {
        formatter: currencyFormat.format}},
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w  }) {
        return (
          '<div class="arrow_box">' +
          '<span>' +
          //[w.globals.labels][dataPointIndex] +
          ['1 yr', '3 yrs', '5 yrs', '10 yrs'][dataPointIndex] +
          ': ' +
          currencyFormat.format(series[seriesIndex][dataPointIndex]) +
          '</span>' +
          '</div>'
        )
      }}}
  const series = [
    {
      data: [
        round(cashFlow1) || 0,
        round(cashFlow3) || 0,
        round(cashFlow5) || 0,
        round(cashFlow10) || 0,
      ],
    },
  ]

  const propertyManagementCompanies = [
    {
      image:
        'https://assets-global.website-files.com/5ebdcacf6fe55d6b95c4f2a1/5f244161238395a76fe1c352_logo-dark-vertical.svg',
      name: 'Mynd',
      //  link: 'https://www.mynd.co/partners/housefolios',
      link: 'https://www.mynd.co',
      value: 'mynd'},
    {
      image: dark365Square,
      name: 'home365',
      link: 'https://www.home365.co',
      value: 'home365'},
    {
      image: '/images/guardianAsset.jpeg',
      name: 'Guardian Asset',
      link: 'https://guardianassetmgt.com/Home/Contact',
      value: 'guardianAsset'},
  ]

  const grossMonthlyIncomeFields = filter(
    [
      {
        type: 'select',
        name: 'rentType',
        label: 'Rent Type',
        value: assumptionsInput.rentType,
        options: assumptionsOptions(activeOrg)?.rentTypes,
        xs: 12,
        lg: 12,
        assumptions: true},
      {
        type: 'dollar',
        name: `rent.${props.activeUnit}`,
        label: 'Total Rental Income',
        tooltipButtonText: 'Show Total Rent data',
        value:
          analysisInput.rent[props.activeUnit] === null
            ? ''
            : analysisInput.rent[props.activeUnit].toString(),
        helper:
          property.sqft &&
          property.sqft[props.activeUnit] &&
          analysisInput.rent[props.activeUnit]
            ? currencyFormat2.format(
                analysisInput.rent[props.activeUnit] /
                  property.sqft[props.activeUnit],
              ) + ' rent per sqft'
            : '$0.00 rent per sqft',
        xs: 12,
        lg: 6,
        definition: 'rent',
        // disabled: !isNil(analysisInput.ownerOccupiedB2R) && props.activeUnit === analysisInput.ownerOccupiedB2R,
        tooltipField:
          "A tenant's monthly payment to a landlord for the use of property or land.",
        hide: assumptionsInput.rentType !== 'singleRent',
        dataTour: 'grossMonthlyIncome-step-1'},
      {
        type: 'dollar',
        name: `rentLow.${props.activeUnit}`,
        label: 'Rent Range Low',
        tooltipButtonText: 'Show Total Rent data',
        value:
          analysisInput.rentLow[props.activeUnit] === null
            ? ''
            : analysisInput.rentLow[props.activeUnit].toString(),
        xs: 12,
        lg: 6,
        definition: 'rent',
        tooltipField: 'Lower end of projected rent',
        hide: assumptionsInput.rentType !== 'rentRange',
        dataTour: ''},
      {
        type: 'dollar',
        name: `rentHigh.${props.activeUnit}`,
        label: 'Rent Range High',
        tooltipButtonText: 'Show Total Rent data',
        value:
          analysisInput.rentHigh[props.activeUnit] === null
            ? ''
            : analysisInput.rentHigh[props.activeUnit].toString(),
        xs: 12,
        lg: 6,
        definition: 'rent',
        tooltipField: 'Higher end of projected rent',
        hide: assumptionsInput.rentType !== 'rentRange',
        dataTour: ''},
      {
        type: 'percentage',
        name: `vacancy.${props.activeUnit}`,
        label: 'Vacancy Rate',
        value: assumptionsInput.vacancy[props.activeUnit],
        xs: 12,
        lg: 6,
        assumptions: true,
        tooltipField:
          'The percentage of time that a property is not rented out during the course of a year.',
        dataTour: 'grossMonthlyIncome-step-2'},
      {
        type: 'dollar',
        name: `otherIncome.${props.activeUnit}`,
        label: 'Other Monthly Income',
        value:
          analysisInput.otherIncome[props.activeUnit] === null
            ? ''
            : analysisInput.otherIncome[props.activeUnit].toString(),
        xs: 12,
        lg: 6,
        tooltipField:
          'Additional income you earn through the property. Some examples might be coin-op laundry, parking, storage, etc.',
        dataTour: 'grossMonthlyIncome-step-3'},
    ],
    (field) => !field.hide,
  )

  const grossMonthlyIncomeChartOptions = createDonutChartOptions(
    currencyFormat,
    concat(
      map(
        analytics.grossAnnualRent,
        (value, index) => `Unit ${index + 1} Monthly Rental Income`,
      ),
      map(
        analysis.otherIncome,
        (value, index) => `Unit ${index + 1} Other Monthly Income`,
      ),
    ),
    pieColors,
  )
  const grossMonthlyIncomeChartSeries = concat(
    map(
      analytics.grossAnnualRent,
      (grossAnnualRent, index) =>
        round(grossAnnualRent / 12, 2) || (index === 0 ? 0.0001 : 0),
    ),
    map(
      analysis.otherIncome,
      (otherIncome) => round(otherIncome, 2) || 0,
    ),
  )

  const expenseCard =
    find(
      cards,
      (card) =>
        card.name === 'expenses' && card.member === activeOrg.member,
    ) ||
    find(
      cards,
      (card) => card.name === 'expenses' && card.member === null,
    ) ||
    {}
  const monthlyExpensesFields = map(
    get(expenseCard, 'card.fields'),
    (field) => {
      const input = field.analytics
        ? analytics.B2R
        : field.assumptions
          ? assumptionsInput
          : analysisInput
      const name = field.suffix
        ? includes(field.name, 'Type')
          ? replace(field.name, 'Type', 'B2RType')
          : field.name + 'B2R'
        : field.name
      const adornmentName =
        field.suffix && field.adornmentName
          ? includes(field.adornmentName, 'Type')
            ? replace(field.adornmentName, 'Type', 'B2RType')
            : field.adornmentName + 'B2R'
          : field.adornmentName
      const definition =
        field.suffix && field.definition
          ? includes(field.definition, 'Type')
            ? replace(field.definition, 'Type', 'B2RType')
            : field.definition + 'B2R'
          : field.definition
      const options =
        field.options && field.assumptions
          ? get(assumptionsOptions(activeOrg), field.options) ||
            get(activeOrg, field.options) ||
            field.options
          : get(activeOrg, field.options) || field.options
      return {
        ...field,
        name,
        value:
          name === 'mortgageB2R'
            ? get(input, 'lotMortgage') +
              get(input, 'constructionMortgage') +
              sum(get(input, 'mezzanineMortgage'))
            : get(input, name),
        adornmentToggle: get(input, adornmentName),
        adornment: get(input, adornmentName),
        adornmentName: adornmentName,
        definition: definition,
        options: options}
    },
  )

  const monthlyExpensesChartOptions = createDonutChartOptions(
    currencyFormat,
    concat(
      [
        'Property Insurance',
        'Property Mgmt Fee',
        'Monthly HOA',
        'Property Taxes',
        'Maintenance',
        'Utilities',
        'Capex',
        'Other Expenses',
        'Mortgage',
      ],
      map(analysis.customMonthlyExpenses, (expense) => expense.type),
    ),
    pieColors,
  )
  const monthlyExpensesChartSeries = concat(
    [
      round(analytics.B2R.propertyInsuranceDollarB2R / 12, 2) ||
        0.0001,
      round(analytics.B2R.propertyManagementDollarB2R / 12, 2) || 0,
      round(analytics.B2R.hoaTotal / 12, 2) || 0,
      round(analysis.propertyTaxes / 12, 2) || 0,
      round(analytics.B2R.maintenanceB2RDollar / 12, 2) || 0,
      round(analytics.B2R.utilitiesTypeDollarB2R, 2) || 0,
      round(analytics.B2R.monthlyReservesTypeDollarB2R, 2) || 0,
      round(assumptions.otherExpenseB2R / 12, 2) || 0,
      round(
        analytics.B2R.lotMortgage +
          analytics.B2R.constructionMortgage +
          sum(analytics.B2R.mezzanineMortgage),
        2,
      ) || 0,
    ],
    map(
      analysis.customMonthlyExpenses,
      (expense) => round(expense.value, 2) || 0,
    ),
  )

  const financingFields = [
    {
      type: 'checkbox',
      label: 'Cash Purchase',
      name: 'allCashPurchaseTurnkey',
      value: assumptionsInput.allCashPurchaseTurnkey,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Investor pays 100% of the purchase price in cash and does not have a mortgage payment.',
      dataTour: 'endBuyerFinancing-step-1'},
    {
      type: 'percentage',
      name: 'downPaymentTurnkey',
      label: 'Down Payment',
      value: assumptionsInput.downPaymentTurnkey || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The amount of cash that a purchaser must put down, toward the purchase price, to buy real estate. The down payment amount is a percentage of the total purchase price, dictated by the lender.',
      dataTour: 'endBuyerFinancing-step-2'},
    {
      type: 'percentage',
      name: 'financingRepairsPercentageTurnkey',
      label: '% of Rehab',
      value: analysisInput.financingRepairsPercentageTurnkey || 0,
      xs: 12,
      lg: 6,
      tooltipField:
        'The percentage of the repair cost that is being covered by the loan',
      dataTour: 'endBuyerFinancing-step-7'},
    {
      type: 'percentage',
      name: 'rateTurnkey',
      label: 'Interest Rate',
      value: assumptionsInput.rateTurnkey || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The interest rate is the amount a lender charges for the use of capital, expressed as a percentage of the principal. The interest rate is typically noted on an annual basis known as the annual percentage rate (APR).',
      dataTour: 'endBuyerFinancing-step-3'},
    {
      type: 'dropdown',
      name: 'termTurnkey',
      label: 'Financing Term',
      value: assumptionsInput.termTurnkey || 0,
      adornment: assumptionsInput.termTurnkeyType,
      adornmentToggle: assumptionsInput.termTurnkeyType,
      adornmentName: 'termTurnkeyType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'The length of time that the loan is being amortized. Expressed in months or years.',
      dataTour: 'endBuyerFinancing-step-4'},
    {
      type: 'number',
      name: 'pointsTurnkey',
      label: 'Points',
      value: assumptionsInput.pointsTurnkey || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Often when you take out a loan, you will pay "points" (aka: fees) on the loan. It is essentially prepaid interest charged by the lender. One point is equal to 1% of the loan amount. For example, a $100,000 loan with 2 points would be $2,000.',
      dataTour: 'endBuyerFinancing-step-5'},
    {
      type: 'checkbox',
      name: 'interestOnlyLoanTurnkey',
      label: 'Interest Only Loan',
      value: assumptionsInput.interestOnlyLoanTurnkey,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A loan that only requires the payment of interest, not principal.',
      dataTour: 'endBuyerFinancing-step-6'},
    // {
    //   type: 'checkbox',
    //   name: 'financingRepairsTurnkey',
    //   label: 'Finance Repairs',
    //   value: analysisInput.financingRepairsTurnkey || false,
    //   xs: 12,
    //   lg: 6,
    //   tooltipField: 'Your down payment adjusts what percentage of your repairs will be financed.',
    //   dataTour: "endBuyerFinancing-step-7",
    // },
  ]

  const lotFinancingFields = [
    {
      type: 'dollar',
      name: 'b2rLotOfferPrice',
      label: 'Purchase Price',
      value:
        analysisInput.b2rLotOfferPrice === null
          ? ''
          : analysisInput.b2rLotOfferPrice.toString(),
      xs: 12,
      lg: 6,
      tooltipField:
        'The dollar amount of the loan meant for the lot.',
      dataTour: 'financing-step-1'},
    {
      type: 'date',
      name: 'lotStartDate',
      label: 'Start Date',
      value: assumptionsInput.lotStartDate,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField: 'The date the lot loan started.',
      dataTour: 'financing-step-2'},
    {
      type: 'checkbox',
      label: 'Cash Purchase',
      name: 'lotCashPurchase',
      value: assumptionsInput.lotCashPurchase,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Investor pays 100% of the purchase price in cash and does not have a mortgage payment.',
      dataTour: 'financing-step-3'},
    {
      type: 'percentage',
      name: 'lotDownPayment',
      label: 'Down Payment',
      value: assumptionsInput.lotDownPayment || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The amount of cash that a purchaser must put down, toward the purchase price, to buy real estate. The down payment amount is a percentage of the total purchase price, dictated by the lender.',
      dataTour: 'financing-step-4'},
    {
      type: 'percentage',
      name: 'lotRate',
      label: 'Interest Rate',
      value: assumptionsInput.lotRate || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The interest rate is the amount a lender charges for the use of capital, expressed as a percentage of the principal. The interest rate is typically noted on an annual basis known as the annual percentage rate (APR).',
      dataTour: 'financing-step-5'},
    //  {
    //    type: 'dropdown',
    //    name: 'lotTerm',
    //    label: 'Financing Term',
    //    value: assumptionsInput.lotTerm || 0,
    //    adornment: assumptionsInput.lotTermType,
    //    adornmentToggle: assumptionsInput.lotTermType,
    //    adornmentName: 'lotTermType',
    //    xs: 12,
    //    lg: 6,
    //    assumptions: true,
    //    dropdown: true,
    //    tooltipField: 'The length of time that the loan is being amortized. Expressed in months or years.',
    //  },
    {
      type: 'number',
      name: 'lotPoints',
      label: 'Points',
      value: assumptionsInput.lotPoints || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Often when you take out a loan, you will pay "points" (aka: fees) on the loan. It is essentially prepaid interest charged by the lender. One point is equal to 1% of the loan amount. For example, a $100,000 loan with 2 points would be $2,000.',
      dataTour: 'financing-step-6'},
    {
      type: 'number',
      name: 'lotDaysOfLoan',
      label: 'Days of loan',
      value: assumptionsInput.lotDaysOfLoan,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The dollar amount of the loan meant for the lot.',
      dataTour: 'financing-step-7'},
    {
      name: 'lotLender',
      value: analysisInput.lotLender || '',
      label: 'Lender',
      options: filter(activeOrg.lenders, (lender) =>
        includes(lender.type, 'Lot'),
      ),
      optionName: 'lenders',
      removeOption: true,
      type: 'select',
      xs: 12,
      lg: 6,
      dataTour: 'financing-step-8'},
    {
      type: 'checkbox',
      name: 'lotInterestOnlyLoan',
      label: 'Interest Only Loan',
      value: assumptionsInput.lotInterestOnlyLoan,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A loan that only requires the payment of interest, not principal.',
      dataTour: 'financing-step-9'},
    //  {
    //    type: 'checkbox',
    //    name: 'financingRepairsB2R',
    //    label: 'Finance Repairs',
    //    value: analysisInput.financingRepairsB2R || false,
    //    xs: 12,
    //    lg: 6,
    //    tooltipField: 'Your down payment adjusts what percentage of your repairs will be financed.',
    //    dataTour: "financing-step-10",
    //  },
  ]

  const constructionFinancingFields = [
    {
      type: 'dollar',
      name: 'b2rConstructionOfferPrice',
      label: 'Loan Amount',
      value:
        analysisInput.b2rConstructionOfferPrice == null
          ? ''
          : analysisInput.b2rConstructionOfferPrice.toString(),
      xs: 12,
      lg: 6,
      tooltipField:
        'The total value of the loan meant for the construction.',
      dataTour: 'constructionLoan-step-1'},
    {
      type: 'date',
      name: 'constructionStartDate',
      label: 'Start Date',
      value: assumptionsInput.constructionStartDate,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField: 'The date the construction loan started.',
      dataTour: 'constructionLoan-step-2'},
    {
      type: 'checkbox',
      label: 'Cash Purchase',
      name: 'constructionCashPurchase',
      value: assumptionsInput.constructionCashPurchase,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Investor pays 100% of the purchase price in cash and does not have a mortgage payment.',
      dataTour: 'constructionLoan-step-3'},
    {
      type: 'percentage',
      name: 'constructionDownPayment',
      label: 'Down Payment',
      value: assumptionsInput.constructionDownPayment || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The amount of cash that a purchaser must put down, toward the purchase price, to buy real estate. The down payment amount is a percentage of the total purchase price, dictated by the lender.',
      dataTour: 'constructionLoan-step-4'},
    {
      type: 'percentage',
      name: 'constructionRate',
      label: 'Interest Rate',
      value: assumptionsInput.constructionRate || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The interest rate is the amount a lender charges for the use of capital, expressed as a percentage of the principal. The interest rate is typically noted on an annual basis known as the annual percentage rate (APR).',
      dataTour: 'constructionLoan-step-5'},
    // {
    //   type: 'dropdown',
    //   name: 'constructionTerm',
    //   label: 'Financing Term',
    //   value: assumptionsInput.constructionTerm || 0,
    //   adornment: assumptionsInput.constructionTermType,
    //   adornmentToggle: assumptionsInput.constructionTermType,
    //   adornmentName: 'constructionTermType',
    //   xs: 12,
    //   lg: 6,
    //   assumptions: true,
    //   dropdown: true,
    //   tooltipField: 'The length of time that the loan is being amortized. Expressed in months or years.',
    // },
    {
      type: 'number',
      name: 'constructionPoints',
      label: 'Points',
      value: assumptionsInput.constructionPoints || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Often when you take out a loan, you will pay "points" (aka: fees) on the loan. It is essentially prepaid interest charged by the lender. One point is equal to 1% of the loan amount. For example, a $100,000 loan with 2 points would be $2,000.',
      dataTour: 'constructionLoan-step-6'},
    {
      name: 'constructionLender',
      value: analysisInput.constructionLender || '',
      label: 'Lender',
      options: filter(activeOrg.lenders, (lender) =>
        includes(lender.type, 'Construction'),
      ),
      optionName: 'lenders',
      removeOption: true,
      type: 'select',
      xs: 12,
      lg: 6,
      dataTour: 'constructionLoan-step-7'},
    {
      type: 'checkbox',
      name: 'constructionInterestOnlyLoan',
      label: 'Interest Only Loan',
      value: assumptionsInput.constructionInterestOnlyLoan,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A loan that only requires the payment of interest, not principal.',
      dataTour: 'constructionLoan-step-8'},
    // {
    //   type: 'checkbox',
    //   name: 'financingRepairsB2R',
    //   label: 'Finance Repairs',
    //   value: analysisInput.financingRepairsB2R || false,
    //   xs: 12,
    //   lg: 6,
    //   tooltipField: 'Your down payment adjusts what percentage of your repairs will be financed.',
    //   dataTour: "constructionLoan-step-9",
    // },
  ]

  const mezzanineFinancingFields = (index) => [
    {
      type: 'dollar',
      name: `b2rMezzanineOfferPrice.${index}`,
      label: 'Loan Amount',
      value: analysisInput.b2rMezzanineOfferPrice[index],
      xs: 12,
      lg: 6,
      tooltipField:
        'The dollar amount of the loan meant for the additional expenses that may occur.',
      dataTour: 'mezzanineLoan-step-1'},
    {
      type: 'date',
      name: `mezzanineStartDate.${index}`,
      label: 'Start Date',
      value: get(assumptionsInput, `mezzanineStartDate.${index}`),
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField: 'The date the mezzanine loan started.',
      dataTour: 'mezzanineLoan-step-2'},
    {
      type: 'checkbox',
      label: 'Cash Purchase',
      name: `mezzanineCashPurchase.${index}`,
      value: assumptionsInput.mezzanineCashPurchase[index],
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Investor pays 100% of the purchase price in cash and does not have a mortgage payment.',
      dataTour: 'mezzanineLoan-step-3'},
    {
      type: 'percentage',
      name: `mezzanineDownPayment.${index}`,
      label: 'Down Payment',
      value: assumptionsInput.mezzanineDownPayment[index] || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The amount of cash that a purchaser must put down, toward the purchase price, to buy real estate. The down payment amount is a percentage of the total purchase price, dictated by the lender.',
      dataTour: 'mezzanineLoan-step-4'},
    {
      type: 'percentage',
      name: `mezzanineRate.${index}`,
      label: 'Interest Rate',
      value: assumptionsInput.mezzanineRate[index] || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The interest rate is the amount a lender charges for the use of capital, expressed as a percentage of the principal. The interest rate is typically noted on an annual basis known as the annual percentage rate (APR).',
      dataTour: 'mezzanineLoan-step-5'},
    // {
    //   type: 'dropdown',
    //   name: `mezzanineTerm.${index}`,
    //   label: 'Financing Term',
    //   value: assumptionsInput.mezzanineTerm[index] || 0,
    //   adornment: assumptionsInput.mezzanineTermType[index],
    //   adornmentToggle: assumptionsInput.mezzanineTermType[index],
    //   adornmentName: `mezzanineTermType.${index}`,
    //   xs: 12,
    //   lg: 6,
    //   assumptions: true,
    //   dropdown: true,
    //   tooltipField: 'The length of time that the loan is being amortized. Expressed in months or years.',
    // },
    {
      type: 'number',
      name: `mezzaninePoints.${index}`,
      label: 'Points',
      value: assumptionsInput.mezzaninePoints[index] || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Often when you take out a loan, you will pay "points" (aka: fees) on the loan. It is essentially prepaid interest charged by the lender. One point is equal to 1% of the loan amount. For example, a $100,000 loan with 2 points would be $2,000.',
      dataTour: 'mezzanineLoan-step-6'},
    {
      name: `mezzanineLender.${index}`,
      value: get(analysisInput, `mezzanineLender.${index}`),
      label: 'Lender',
      options: filter(activeOrg.lenders, (lender) =>
        includes(lender.type, 'Mezzanine'),
      ),
      optionName: 'lenders',
      removeOption: true,
      type: 'select',
      xs: 12,
      lg: 6,
      dataTour: 'mezzanineLoan-step-7'},
    {
      type: 'checkbox',
      name: `mezzanineInterestOnlyLoan.${index}`,
      label: 'Interest Only Loan',
      value: assumptionsInput.mezzanineInterestOnlyLoan[index],
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A loan that only requires the payment of interest, not principal.',
      dataTour: 'mezzanineLoan-step-8'},
    // {
    //   type: 'checkbox',
    //   name: 'financingRepairsB2R',
    //   label: 'Finance Repairs',
    //   value: analysisInput.financingRepairsB2R || false,
    //   xs: 12,
    //   lg: 6,
    //   tooltipField: 'Your down payment adjusts what percentage of your repairs will be financed.',
    //   dataTour: "mezzanineLoan-step-9",
    // },
  ]

  const projectionCard =
    find(
      cards,
      (card) =>
        card.name === 'projection' &&
        card.member === activeOrg.member,
    ) ||
    find(
      cards,
      (card) => card.name === 'projection' && card.member === null,
    ) ||
    {}
  const projectionAssumptionsFields = map(
    get(projectionCard, 'card.fields'),
    (field) => {
      const input = field.analytics
        ? analytics.B2R
        : field.assumptions
          ? assumptionsInput
          : analysisInput
      const name = field.suffix
        ? includes(field.name, 'Type')
          ? replace(field.name, 'Type', 'B2RType')
          : field.name + 'B2R'
        : field.name
      const adornmentName =
        field.suffix && field.adornmentName
          ? includes(field.adornmentName, 'Type')
            ? replace(field.adornmentName, 'Type', 'B2RType')
            : field.adornmentName + 'B2R'
          : field.adornmentName
      const definition =
        field.suffix && field.definition
          ? includes(field.definition, 'Type')
            ? replace(field.definition, 'Type', 'B2RType')
            : field.definition + 'B2R'
          : field.definition
      return {
        ...field,
        name,
        value: get(input, name),
        adornmentToggle: get(input, adornmentName),
        adornment: get(input, adornmentName),
        adornmentName: adornmentName,
        definition: definition}
    },
  )

  const chartOptions = createCashflowChartOptions(currencyFormat)
  const chartSeries = [
    {
      data: [
        round(sum(grossMonthlyIncomeChartSeries)) || 0,
        round(sum(monthlyExpensesChartSeries)) || 0,
        round(
          sum(grossMonthlyIncomeChartSeries) -
            sum(monthlyExpensesChartSeries),
        ) || 0,
      ],
      // colors: [
      //   ranges: [
      //     {
      //       from: 100,
      //       to: 0,
      //       color: '#f83145',
      //     },
      //   ],
      // ],
    },
  ]

  const strategySummary = createStrategySummary(
    analytics,
    'B2R',
    'Build to Rent',
    [
      {
        value: analytics.B2R.cashFlowB2R / 12 || '-',
        arrow: analytics.B2R.cashFlowB2RArrow || 0,
        label: 'Net Cashflow',
        type: 'currency',
        target: assumptions.belowB2RCashFlow,
        targetLabel: 'Min Net Cashflow Target',
        targetName: 'belowB2RCashFlow',
        tourStep: 'targets-step-1',
        min: 0,
        max: 2000,
        minLabel: '$ 0k',
        maxLabel: '$ 2k',
        step: 100,
        valueLabelFormat: (x) =>
          x >= 1000 ? `${x / 1000}k` : `${x}`,
        description:
          'Net cashflow is the amount of money left after the mortgage and any other expenses are paid.',
        calculation: (
          <>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Gross Annual Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(sum(grossMonthlyIncomeChartSeries) * 12),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Property Mgmt
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.propertyManagementDollarB2R,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Maintenance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.B2R.maintenanceB2RDollar, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Insurance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.propertyInsuranceDollarB2R,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Taxes
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analysis.propertyTaxes, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -HOA Fees
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.B2R.hoaTotal, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Asset management
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.assetManagementFeeTotalB2R,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Utilities
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.utilitiesTypeDollarB2R * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Capex
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.monthlyReservesTypeDollarB2R * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Other
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(assumptions.otherExpenseB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Custom Expenses
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.customMonthlyExpenseTotal * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Operating Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.B2R.netOperatingIncomeB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Annual Mortgage
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      (analytics.B2R.lotMortgage +
                        analytics.B2R.constructionMortgage +
                        sum(analytics.B2R.mezzanineMortgage)) *
                        12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Annual Cashflow
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.B2R.cashFlowB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  12 months
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  12
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Monthly Cashflow
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.B2R.cashFlowB2R / 12, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
          </>
        )},
      {
        value: analytics.B2R.cashOnCashReturnB2R || '-',
        arrow: analytics.B2R.cashOnCashReturnB2RArrow || 0,
        label: 'CoC ROI',
        target: assumptions.belowB2RCashOnCashReturn,
        targetLabel: 'Min Cash on Cash Return Target',
        targetName: 'belowB2RCashOnCashReturn',
        tourStep: 'targets-step-2',
        min: 0,
        max: 25,
        minLabel: '0%',
        maxLabel: '25%',
        description:
          'A cash-on-cash return calculates the return on the money put in by the investor on a property with a mortgage.  Commonly referred to as a Leveraged Return.',
        calculation: (
          <>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Gross Annual Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(sum(grossMonthlyIncomeChartSeries) * 12),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Property Mgmt
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.propertyManagementDollarB2R,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Maintenance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.B2R.maintenanceB2RDollar, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Insurance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.propertyInsuranceDollarB2R,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Taxes
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analysis.propertyTaxes, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -HOA Fees
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.B2R.hoaTotal, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Asset management
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.assetManagementFeeTotalB2R,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Utilities
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.utilitiesTypeDollarB2R * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Capex
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.monthlyReservesTypeDollarB2R * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Other
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(assumptions.otherExpenseB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Custom Expenses
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.customMonthlyExpenseTotal * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Operating Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.B2R.netOperatingIncomeB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Annual Mortgage
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      (analytics.B2R.lotMortgage +
                        analytics.B2R.constructionMortgage +
                        sum(analytics.B2R.mezzanineMortgage)) *
                        12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Annual Cashflow
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.B2R.cashFlowB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  Total Out-of-Pocket
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  {currencyFormat.format(
                    round(analytics.B2R.totalOutOfPocketB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Cash on Cash Return
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {percentageFormat.format(
                    analytics.B2R.cashOnCashReturnB2R,
                  )}
                </Typography>
              </Grid>
            </Grid>
          </>
        )},
      {
        value: analytics.B2R.capRateB2R,
        arrow: analytics.B2R.capRateB2RArrow || 0,
        label: 'Cap Rate',
        target: assumptions.belowB2RCapRate,
        targetLabel: 'Min Cap Rate Target',
        targetName: 'belowB2RCapRate',
        tourStep: 'targets-step-3',
        min: 0,
        max: 25,
        minLabel: '0%',
        maxLabel: '25%',
        description:
          'The capitalization rate (cap rate) is utilized for several reasons inside real estate investing including real estate valuation, comparing properties to each other, analyzing a market, etc. The higher the cap rate the higher your returns/risk.',
        calculation: (
          <>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Gross Annual Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(sum(grossMonthlyIncomeChartSeries) * 12),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Property Mgmt
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.propertyManagementDollarB2R,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Maintenance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.B2R.maintenanceB2RDollar, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Insurance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.propertyInsuranceDollarB2R,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Taxes
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analysis.propertyTaxes, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -HOA Fees
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.B2R.hoaTotal, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Asset management
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.assetManagementFeeTotalB2R,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Utilities
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.utilitiesTypeDollarB2R * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Capex
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.B2R.monthlyReservesTypeDollarB2R * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Other
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(assumptions.otherExpenseB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Custom Expenses
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.customMonthlyExpenseTotal * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Operating Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.B2R.netOperatingIncomeB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  All-in-cost
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  {currencyFormat.format(
                    round(analytics.B2R.allInCostB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Cap Rate
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {percentageFormat.format(analytics.B2R.capRateB2R)}
                </Typography>
              </Grid>
            </Grid>
          </>
        )},
      {
        value: analytics.B2R.IRRB2R || '-',
        arrow: analytics.B2R.IRRB2RArrow || 0,
        label: 'IRR',
        target: assumptions.belowB2RIRR,
        targetLabel: 'Min IRR Target',
        targetName: 'belowB2RIRR',
        tourStep: 'targets-step-4',
        min: 0,
        max: 30,
        minLabel: '0%',
        maxLabel: '30%',
        description:
          'The internal rate of return (IRR) measures the rate of return earned on an investment during a specific time frame. It includes the recurring cash flow (rent, etc.) and any profits made from the property’s sale. Simply put, IRR represents a property’s net cash flow and expected appreciation divided by the hold time.\nWhile IRR is a helpful way to estimate your asset’s performance over the entire time that you plan to hold it, it relies heavily on forecasting years of cash flow and a projected sale price.',
        calculation: (
          <>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategySectionLabelSx}>
                  Due to the complexity of this calculation, we only
                  show an overview of what goes into calculating the
                  IRR
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Initial Investment (Out of pocket)
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(analytics.B2R.totalOutOfPocketB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Gross Monthly Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(sum(grossMonthlyIncomeChartSeries)),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Rent Growth Rate
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {assumptions.growthRateIncome}%
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Monthly Expenses
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(sum(monthlyExpensesChartSeries)),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Expenses Growth Rate
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {assumptions.growthRateExpense}%
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  After Repair Value
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(analytics.B2R.arvTotalB2R, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Appreciation Rate
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {assumptions.homePriceAppreciation}%
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Holding Period (years)
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {assumptions.rentalHoldingPeriodB2R}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Future property sale
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(
                      analytics.B2R.lotFutureSaleValue +
                        analytics.B2R.constructionFutureSaleValue +
                        sum(analytics.B2R.mezzanineFutureSaleValue),
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  IRR
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {percentageFormat.format(analytics.B2R.IRRB2R)}
                </Typography>
              </Grid>
            </Grid>
            {/* <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
               <Grid>
                 <Typography sx={strategyMutedTextSx}>-Annual Expenses</Typography>
               </Grid>
               <Grid>
                 <Typography sx={strategyMutedTextSx}>-1,308</Typography>
               </Grid>
             </Grid>
             <Divider sx={strategyMutedDividerSx} />
             <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
               <Grid>
                 <Typography sx={strategyMutedTextSx}>Net Operating Income</Typography>
               </Grid>
               <Grid>
                 <Typography sx={strategyMutedTextSx}>14892</Typography>
               </Grid>
             </Grid>
             <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
               <Grid>
                 <Typography sx={strategyMutedTextSx}>
                   <FontAwesomeIcon icon={['fal', 'divide']} style={strategyIconGapStyle} />All-in-cost
                 </Typography>
               </Grid>
               <Grid>
                 <Typography sx={strategyMutedTextSx}>
                   <FontAwesomeIcon icon={['fal', 'divide']} style={strategyIconGapStyle} />14,892
                 </Typography>
               </Grid>
             </Grid>
             <Divider sx={strategyMutedDividerSx} />
             <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
               <Grid>
                 <Typography sx={strategyMutedTextSx}>Cap Rate</Typography>
               </Grid>
               <Grid>
                 <Typography sx={strategyMutedTextSx}>12.82%</Typography>
               </Grid>
             </Grid> */}
          </>
        ),
        extraContent: (
          <Grid size={12} sx={strategyMarginBottom10Sx}>
                                  <Box sx={{
                                    "& > .MuiPaper-root": {
                                      overflow: "hidden",
                                      boxShadow: "none !important",
                                      borderRadius: 0,
                                      "&:first-of-type": { borderTopLeftRadius: "0.65rem", borderTopRightRadius: "0.65rem" },
                                      "&:last-of-type": { borderBottomLeftRadius: "0.65rem", borderBottomRightRadius: "0.65rem" },
                                      "&:not(:last-of-type)": { borderBottom: 0 },
                                      "& > .MuiPaper-root": { boxShadow: "none !important", borderRadius: "inherit" },
                                    },
                                    "& .panel-title, & .accordion-toggle, & [data-hf=\"panel-title\"], & [data-hf=\"accordion-toggle\"]": { width: "100%", display: "block" },
                                    "& .MuiCard-root > div:has(> .panel-title), & .MuiCard-root > div:has(> [data-hf=\"panel-title\"])": {
                                      display: "block !important",
                                      padding: "0 !important",
                                      width: "100%",
                                      backgroundColor: "transparent !important",
                                    },
                                    "& > .card": {
                                      overflow: "hidden",
                                      "&:not(:last-of-type)": { borderBottom: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 },
                                      "&:not(:first-of-type)": { borderTopLeftRadius: 0, borderTopRightRadius: 0 },
                                      "& > .card-header": { borderRadius: 0, marginBottom: 0 },
                                    },
                                  }}>
                                    <Card variant="outlined" sx={(accordion === 0) && {
                                      "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                                        borderBottomColor: "rgba(79, 80, 98, 0.3)",
                                        background: "#fff",
                                        color: "#070919 !important",
                                        "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
                                      },
                                      "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
                                    }}>
                                      <Card>
                                        <Box sx={strategyTableRowSx}>
                                          <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                                            <Box data-hf="accordion-toggle" sx={{
                                              "& .MuiButton-root": {
                                                display: "flex",
                                                width: "100%",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                textAlign: "left",
                                                fontWeight: 700,
                                                color: "#3b3e66 !important",
                                                textDecoration: "none !important",
                                                textTransform: "none",
                                                borderRadius: 0,
                                                padding: "0.75rem 1.25rem !important",
                                                borderBottom: "1px solid transparent",
                                                background: "#f4f5fd",
                                                "&:hover": {
                                                  background: "#f8f9ff !important",
                                                  color: "#070919 !important",
                                                  textDecoration: "none !important",
                                                  "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                                                },
                                                "&:not(:disabled):hover": { transform: "translateY(0px)" },
                                                "& [data-hf=\"accordion-icon\"]": {
                                                  transform: "rotate(90deg)",
                                                  transition: "all 0.2s ease-in-out",
                                                  marginLeft: "auto",
                                                  color: "#368cff !important",
                                                  overflow: "visible",
                                                },
                                              },
                                              "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                                                background: "#2a2a2a !important",
                                                color: "rgba(255, 255, 255, 0.9) !important",
                                                "&:hover": { background: "#333 !important", color: "#fff !important" },
                                              },
                                            }}>
                                              <Button
                                                variant="text"
                                                size="large"
                                                sx={{
                                                  fontWeight: 700,
                                                  color: "#3b3e66",
                                                  textDecoration: "none",
                                                  "&:hover": {
                                                    backgroundColor: "transparent",
                                                    color: "#4191ff",
                                                    textDecoration: "underline",
                                                    transform: "translateY(0px)",
                                                  },
                                                  "&:active": { textDecoration: "underline", boxShadow: "none" },
                                                  "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                                                  "& span": {
                                                    position: "relative",
                                                    "&::before": {
                                                      content: "\"\"",
                                                      position: "absolute",
                                                      width: "100%",
                                                      height: 2,
                                                      bottom: 0,
                                                      left: 0,
                                                      visibility: "hidden",
                                                      transform: "scaleX(0)",
                                                      transition: "all 0.3s ease-in-out 0s",
                                                    },
                                                    transition: "all 0.2s ease-in-out",
                                                  },
                                                  "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                                                  "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                                                  "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "space-between",
                                                }}
                                                onClick={() =>
                                                  toggleAccordion(0)
                                                }
                                                aria-expanded={
                                                  accordion === 0
                                                }
                                              >
                                                <span>
                                                  Start Month
                                                </span>
                                                <FontAwesomeIcon icon={[ 'fas', 'angle-up', ]} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                        <Collapse
                                          in={accordion === 0}
                                        >
                                          <Paper sx={strategyFullWidthHiddenSx}>
                                            <TableContainer sx={strategyMaxHeight440Sx}>
                                              <Table
                                                stickyHeader
                                                aria-label="sticky table"
                                              >
                                                <TableHead>
                                                  <TableRow>
                                                    {IRRTableFirstHeaders.map(
                                                      (row) => (
                                                        <TableCell
                                                          align={
                                                            row.align
                                                          }
                                                        >
                                                          {row.name}
                                                        </TableCell>
                                                      ),
                                                    )}
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  <TableRow
                                                    key={
                                                      IRRDataFirst.name
                                                    } sx={strategyTableRowLastSx}>
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                    >
                                                      {
                                                        IRRDataFirst.monthYear
                                                      }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      {currencyFormat2.format(
                                                        IRRDataFirst.totalOutOfPocket,
                                                      )}
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </Paper>
                                        </Collapse>
                                      </Card>
                                    </Card>
                                    <Card variant="outlined" sx={(accordion === 1) && {
                                      "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                                        borderBottomColor: "rgba(79, 80, 98, 0.3)",
                                        background: "#fff",
                                        color: "#070919 !important",
                                        "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
                                      },
                                      "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
                                    }}>
                                      <Card>
                                        <Box sx={strategyTableRowSx}>
                                          <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                                            <Box data-hf="accordion-toggle" sx={{
                                              "& .MuiButton-root": {
                                                display: "flex",
                                                width: "100%",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                textAlign: "left",
                                                fontWeight: 700,
                                                color: "#3b3e66 !important",
                                                textDecoration: "none !important",
                                                textTransform: "none",
                                                borderRadius: 0,
                                                padding: "0.75rem 1.25rem !important",
                                                borderBottom: "1px solid transparent",
                                                background: "#f4f5fd",
                                                "&:hover": {
                                                  background: "#f8f9ff !important",
                                                  color: "#070919 !important",
                                                  textDecoration: "none !important",
                                                  "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                                                },
                                                "&:not(:disabled):hover": { transform: "translateY(0px)" },
                                                "& [data-hf=\"accordion-icon\"]": {
                                                  transform: "rotate(90deg)",
                                                  transition: "all 0.2s ease-in-out",
                                                  marginLeft: "auto",
                                                  color: "#368cff !important",
                                                  overflow: "visible",
                                                },
                                              },
                                              "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                                                background: "#2a2a2a !important",
                                                color: "rgba(255, 255, 255, 0.9) !important",
                                                "&:hover": { background: "#333 !important", color: "#fff !important" },
                                              },
                                            }}>
                                              <Button
                                                variant="text"
                                                size="large"
                                                sx={{
                                                  fontWeight: 700,
                                                  color: "#3b3e66",
                                                  textDecoration: "none",
                                                  "&:hover": {
                                                    backgroundColor: "transparent",
                                                    color: "#4191ff",
                                                    textDecoration: "underline",
                                                    transform: "translateY(0px)",
                                                  },
                                                  "&:active": { textDecoration: "underline", boxShadow: "none" },
                                                  "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                                                  "& span": {
                                                    position: "relative",
                                                    "&::before": {
                                                      content: "\"\"",
                                                      position: "absolute",
                                                      width: "100%",
                                                      height: 2,
                                                      bottom: 0,
                                                      left: 0,
                                                      visibility: "hidden",
                                                      transform: "scaleX(0)",
                                                      transition: "all 0.3s ease-in-out 0s",
                                                    },
                                                    transition: "all 0.2s ease-in-out",
                                                  },
                                                  "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                                                  "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                                                  "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "space-between",
                                                }}
                                                onClick={() =>
                                                  toggleAccordion(1)
                                                }
                                                aria-expanded={
                                                  accordion === 1
                                                }
                                              >
                                                <span>
                                                  Appreciation Months
                                                </span>
                                                <FontAwesomeIcon icon={[ 'fas', 'angle-up', ]} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                        <Collapse
                                          in={accordion === 1}
                                        >
                                          <Paper sx={strategyFullWidthHiddenSx}>
                                            <TableContainer sx={strategyMaxHeight440Sx}>
                                              <Table
                                                stickyHeader
                                                aria-label="sticky table"
                                              >
                                                <TableHead>
                                                  <TableRow>
                                                    {IRRTableHeaders.map(
                                                      (row) => (
                                                        <TableCell
                                                          align={
                                                            row.align
                                                          }
                                                        >
                                                          {row.name}
                                                        </TableCell>
                                                      ),
                                                    )}
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  {IRRData.map(
                                                    (row) => (
                                                      <>
                                                        <TableRow
                                                          key={
                                                            row.name
                                                          } sx={{
                                                            '&:last-child td, &:last-child th':
                                                              {
                                                                border: 0}}}>
                                                          <TableCell
                                                            component="th"
                                                            scope="row"
                                                          >
                                                            {
                                                              row.monthYear
                                                            }
                                                          </TableCell>
                                                          <TableCell align="center">
                                                            {currencyFormat2.format(
                                                              row.income,
                                                            )}
                                                          </TableCell>
                                                          <TableCell align="center">
                                                            {currencyFormat2.format(
                                                              row.expenses,
                                                            )}
                                                          </TableCell>
                                                          <TableCell align="center">
                                                            {currencyFormat2.format(
                                                              row.mortgage,
                                                            )}
                                                          </TableCell>
                                                          <TableCell align="center">
                                                            {currencyFormat2.format(
                                                              row.flow,
                                                            )}
                                                          </TableCell>
                                                        </TableRow>
                                                      </>
                                                    ),
                                                  )}
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </Paper>
                                        </Collapse>
                                      </Card>
                                    </Card>
                                    <Card variant="outlined" sx={(accordion === 2) && {
                                      "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                                        borderBottomColor: "rgba(79, 80, 98, 0.3)",
                                        background: "#fff",
                                        color: "#070919 !important",
                                        "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
                                      },
                                      "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
                                    }}>
                                      <Card>
                                        <Box sx={strategyTableRowSx}>
                                          <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                                            <Box data-hf="accordion-toggle" sx={{
                                              "& .MuiButton-root": {
                                                display: "flex",
                                                width: "100%",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                textAlign: "left",
                                                fontWeight: 700,
                                                color: "#3b3e66 !important",
                                                textDecoration: "none !important",
                                                textTransform: "none",
                                                borderRadius: 0,
                                                padding: "0.75rem 1.25rem !important",
                                                borderBottom: "1px solid transparent",
                                                background: "#f4f5fd",
                                                "&:hover": {
                                                  background: "#f8f9ff !important",
                                                  color: "#070919 !important",
                                                  textDecoration: "none !important",
                                                  "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                                                },
                                                "&:not(:disabled):hover": { transform: "translateY(0px)" },
                                                "& [data-hf=\"accordion-icon\"]": {
                                                  transform: "rotate(90deg)",
                                                  transition: "all 0.2s ease-in-out",
                                                  marginLeft: "auto",
                                                  color: "#368cff !important",
                                                  overflow: "visible",
                                                },
                                              },
                                              "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                                                background: "#2a2a2a !important",
                                                color: "rgba(255, 255, 255, 0.9) !important",
                                                "&:hover": { background: "#333 !important", color: "#fff !important" },
                                              },
                                            }}>
                                              <Button
                                                variant="text"
                                                size="large"
                                                sx={{
                                                  fontWeight: 700,
                                                  color: "#3b3e66",
                                                  textDecoration: "none",
                                                  "&:hover": {
                                                    backgroundColor: "transparent",
                                                    color: "#4191ff",
                                                    textDecoration: "underline",
                                                    transform: "translateY(0px)",
                                                  },
                                                  "&:active": { textDecoration: "underline", boxShadow: "none" },
                                                  "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                                                  "& span": {
                                                    position: "relative",
                                                    "&::before": {
                                                      content: "\"\"",
                                                      position: "absolute",
                                                      width: "100%",
                                                      height: 2,
                                                      bottom: 0,
                                                      left: 0,
                                                      visibility: "hidden",
                                                      transform: "scaleX(0)",
                                                      transition: "all 0.3s ease-in-out 0s",
                                                    },
                                                    transition: "all 0.2s ease-in-out",
                                                  },
                                                  "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                                                  "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                                                  "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "space-between",
                                                }}
                                                onClick={() =>
                                                  toggleAccordion(2)
                                                }
                                                aria-expanded={
                                                  accordion === 2
                                                }
                                              >
                                                <span>
                                                  Final Month
                                                </span>
                                                <FontAwesomeIcon icon={[ 'fas', 'angle-up', ]} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                        <Collapse
                                          in={accordion === 2}
                                        >
                                          <Paper sx={strategyFullWidthHiddenSx}>
                                            <TableContainer sx={strategyMaxHeight440Sx}>
                                              <Table
                                                stickyHeader
                                                aria-label="sticky table"
                                              >
                                                <TableHead>
                                                  <TableRow>
                                                    {IRRTableLastHeaders.map(
                                                      (row) => (
                                                        <TableCell
                                                          align={
                                                            row.align
                                                          }
                                                        >
                                                          {row.name}
                                                        </TableCell>
                                                      ),
                                                    )}
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  <TableRow
                                                    key={
                                                      IRRDataLast.name
                                                    } sx={strategyTableRowLastSx}>
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                    >
                                                      {
                                                        IRRDataLast.monthYear
                                                      }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      {currencyFormat2.format(
                                                        IRRDataLast.lastMonthCashFlow,
                                                      )}
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </Paper>
                                        </Collapse>
                                      </Card>
                                    </Card>
                                  </Box>
                                </Grid>
        )},
    ],
    {
      belowKey: 'belowTargetB2R',
      onKey: 'onTargetB2R',
      aboveKey: 'aboveTargetB2R'},
  )

  const financials = [
    {
      value: analytics.B2R.allInCostB2R,
      label: 'All-in Cost',
      description:
        'Total amount of initial investment into a property, including renovation and points paid for financing.',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Purchase Price
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(
                    analysis.b2rLotOfferPrice +
                      analysis.b2rConstructionOfferPrice +
                      sum(analysis.b2rMezzanineOfferPrice),
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Commission
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.B2R.b2rAcquisitionCommissionDollar,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.acquisitionFee, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.B2R.b2rCloseCostDollar, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.B2R.lotPointsAmount +
                      analytics.B2R.constructionPointsAmount +
                      sum(analytics.B2R.mezzaninePointsAmount),
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Financing Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.B2R.lotFinancingFeeTotal +
                      analytics.B2R.constructionFinancingFeeTotal +
                      sum(analytics.B2R.mezzanineFinancingFeeTotal),
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Owner Reserves
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.ownerReservesB2R, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Custom Acquisition Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.customAcquisitionExpenseTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                All-in Cost
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.B2R.allInCostB2R, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
    {
      value: analytics.B2R.totalOutOfPocketB2R,
      label: 'Total Out-of-Pocket',
      description:
        'Total amount of cash that a buyer has put into a property of his/her own capital.',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Down Payment
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(
                    analytics.B2R.lotDownPaymentTotal +
                      analytics.B2R.constructionDownPaymentTotal +
                      sum(analytics.B2R.mezzanineDownPaymentTotal),
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Commission
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.B2R.b2rAcquisitionCommissionDollar,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.acquisitionFee, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.B2R.b2rCloseCostDollar, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Financing Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.B2R.lotFinancingFeeTotal +
                      analytics.B2R.constructionFinancingFeeTotal +
                      sum(analytics.B2R.mezzanineFinancingFeeTotal),
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.B2R.lotPointsAmount +
                      analytics.B2R.constructionPointsAmount +
                      sum(analytics.B2R.mezzaninePointsAmount),
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Total Out-of-Pocket
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.B2R.totalOutOfPocketB2R, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
    {
      value: analytics.turnkey.allInCostTurnkey,
      label: 'All-in Cost End Buyer',
      description:
        'Total amount of initial investment into a property, including renovation and points paid for financing.',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Purchase Price
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(
                    analysis.turnkeyOfferPrice ||
                      analysis.resellPriceTurnkey ||
                      analytics.turnkey.arvTotalTurnkey,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Commission
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.acquisitionCommissionDollarTurnkey,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.acquisitionFee, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.turnkey.closeCostDollarTurnkey, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.turnkey.pointsAmountTurnkey, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Rehab Amount
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.turnkey.corTotalTurnkey, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Financing Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.turnkey.financingFeeTotalTurnkey,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Owner Reserves
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.ownerReservesTurnkey, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Custom Acquisition Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.customAcquisitionExpenseTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                All-in Cost
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.turnkey.allInCostTurnkey, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
    {
      value: analytics.turnkey.totalOutOfPocketTurnkey,
      label: 'Total Out-of-Pocket End Buyer',
      description:
        'Total amount of cash that a buyer has put into a property of his/her own capital.',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Down Payment
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(analytics.turnkey.downPaymentTotalTurnkey, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Commission
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.acquisitionCommissionDollarTurnkey,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.acquisitionFee, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.turnkey.closeCostDollarTurnkey, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Financing Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.turnkey.financingFeeTotalTurnkey,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.turnkey.pointsAmountTurnkey, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Custom Acquisition Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.customAcquisitionExpenseTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Rehab Amount
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.turnkey.repairsOutOfPocketTurnkey,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Total Out-of-Pocket
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.turnkey.totalOutOfPocketTurnkey, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
  ]

  const compData = calculateCompData({
    compValues: props.compValues,
    lowestAverage: props.lowestAverage})

  const buildToRentCards = [
    {
      name: 'strategy',
      card: (
        <StrategyCard
          strategyName="Build to Rent"
          activeOrg={activeOrg}
          percentage={strategySummary.percentage}
          onStrategyTourClick={toggleStrategyTour}
          shared={props.shared}
          property={property}
          canDrag={props.canDrag}
          contactAgent={
            !props.shared &&
            activeOrg.member !== 'gorillacapital' ? (
              <Box sx={strategyCardBodyPadSx}>
                <ContactAgent
                  property={property}
                  propertyPage={true}
                  canDrag={props.canDrag}
                />
              </Box>
            ) : null
          }
        />
      )},
    {
      name: 'targets',
      card: (
        <TargetsCard
          strategySummary={strategySummary}
          currencyFormat={currencyFormat}
          percentageFormat={percentageFormat}
          modal1={modal1}
          toggle1={toggle1}
          toggle1Close={toggle1Close}
          renderInputFields={renderInputFields}
          assumptionsInput={assumptionsInput}
          maxOfferPrice={analytics.B2R.maxB2RPrice}
          toggleMaxOffer={toggleMaxOffer}
          maxOfferDescription={maxOfferDescription}
          onTargetsTourClick={toggleTargetsTour}
          maxOfferCalculation={
            <>
                        <Grid
                          container
                          sx={[strategyMetricRowSx, {
                            alignItems: "center",
                            justifyContent: "space-between"
                          }]}>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              New Asking Price:
                            </Typography>
                          </Grid>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              {currencyFormat.format(
                                analysisInput.resellPriceB2R,
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          sx={[strategyMetricRowSx, {
                            alignItems: "center",
                            justifyContent: "space-between"
                          }]}>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              Purchase Price:
                            </Typography>
                          </Grid>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              {currencyFormat.format(
                                analysisInput.b2rLotOfferPrice,
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          sx={[strategyMetricRowSx, {
                            alignItems: "center",
                            justifyContent: "space-between"
                          }]}>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              ARV:
                            </Typography>
                          </Grid>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              {currencyFormat.format(
                                analytics.B2R.arvTotalB2R,
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          sx={[strategyMetricRowSx, {
                            alignItems: "center",
                            justifyContent: "space-between"
                          }]}>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              All In Cost:
                            </Typography>
                          </Grid>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              {currencyFormat.format(
                                analytics.B2R.allInCostB2R,
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          sx={[strategyMetricRowSx, {
                            alignItems: "center",
                            justifyContent: "space-between"
                          }]}>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              Total Out Of Pocket:
                            </Typography>
                          </Grid>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              {currencyFormat.format(
                                analytics.B2R.totalOutOfPocketB2R,
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          sx={[strategyMetricRowSx, {
                            alignItems: "center",
                            justifyContent: "space-between"
                          }]}>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              Annual Cash Flow:
                            </Typography>
                          </Grid>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              {currencyFormat.format(
                                analytics.B2R.cashFlowB2R,
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          sx={[strategyMetricRowSx, {
                            alignItems: "center",
                            justifyContent: "space-between"
                          }]}>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              Holding Period (yr):
                            </Typography>
                          </Grid>
                          <Grid>
                            <Typography sx={strategyMutedTextSx}>
                              {
                                assumptionsInput.rentalHoldingPeriodB2R
                              }
                            </Typography>
                          </Grid>
                        </Grid>
                      </>
          }
        />
      )},
    {
      name: 'monthlyCashflow',
      card: (
        <Card variant="outlined" sx={{ width: "100%" }}>
          <Box sx={strategyTableRowSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <Box component="small" sx={strategyUppercaseMetaSx}>
                Summary
              </Box>
              <b>Monthly Cashflow</b>
            </Box>
            <div>
              <Tooltip title="Shows the income, expenses, and projected overall cashflow of the property">
                <Button
                  onClick={() =>
                    setOpenBuildToRentMonthlyCashflowTour(true)
                  }
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Grid>
              <Box sx={{
                borderRadius: "0.65rem",
                p: 1.5,
                mb: 1,
                bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
                textAlign: "center",
                border: "1px solid rgba(59, 62, 102, 0.1)",
                "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  px: 1.25,
                  py: 0.75,
                  gap: 0.25,
                  boxSizing: "border-box",
                },
                "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
                "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
                  minHeight: "2.6em",
                  lineHeight: 1.3,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  px: 0.5,
                  boxSizing: "border-box",
                },
                "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
                "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
                  color: "#070919",
                  fontWeight: 700,
                  fontSize: "1.15rem",
                  lineHeight: 1.2,
                },
              }}>
                <Grid
                  container
                  sx={{ color: "rgba(59, 62, 102, 0.5)" }}
                >
                  <Grid
                    size={{ xs: 4 }}
                    data-tour="monthlyCashflow-step-1"
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>Income</Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          <Box component="span" sx={strategyMetricDotGreenSx}>
                            fast
                          </Box>
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={
                                sum(grossMonthlyIncomeChartSeries) /
                                1000
                              }
                              duration={1}
                              separator=","
                              delay={2}
                              decimals={1}
                              decimal="."
                              prefix="$"
                              suffix="k"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    size={{ xs: 4 }}
                    data-tour="monthlyCashflow-step-2"
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>Expenses</Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          <Box component="span" sx={strategyMetricDotRedSx}>
                            normal
                          </Box>
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={
                                sum(monthlyExpensesChartSeries) / 1000
                              }
                              duration={1}
                              delay={2}
                              decimals={1}
                              decimal="."
                              prefix="$"
                              suffix="k"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    size={{ xs: 4 }}
                    data-tour="monthlyCashflow-step-3"
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>Cashflow</Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          <Box component="span" sx={strategyMetricDotBlueSx}>
                            slow
                          </Box>
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={
                                (sum(grossMonthlyIncomeChartSeries) -
                                  sum(monthlyExpensesChartSeries)) /
                                1000
                              }
                              duration={1}
                              delay={2}
                              decimals={1}
                              decimal="."
                              prefix="$"
                              suffix="k"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                </Grid>
              </Box>
              <>
                <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                  <Box sx={{ width: '100%', minWidth: 0, overflow: 'visible' }}>
                  <Chart
                    options={chartOptions}
                    series={chartSeries}
                    type="bar"
                    width="100%"
                    height={250}
                  />
                  </Box>
                </Suspense>
              </>
            </Grid>
          </CardContent>
        </Card>
      ),
    },

    {
      name: 'income',
      card: (
        <Card variant="outlined" sx={{ width: "100%" }}>
          <Grid
            container
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              py: "0.75rem",
              px: "1.25rem",
              mb: 0,
              backgroundColor: "#fff",
              "html[data-color-mode=\"dark\"] &": { backgroundColor: "#1e1e1e !important", color: "rgba(255, 255, 255, 0.87)" },
            }}
            direction="row"
          >
            <Grid size={8} sx={{ minWidth: 0 }}>
              <List sx={{
                display: "flex",
                alignItems: "stretch",
                gap: 0.5,
                p: 0,
                m: 0,
                minHeight: 40,
              }}>
                {analysisInput.rent.length > 1 ? (
                  map(analysisInput.rent, (value, index) => (
                    <ListItemButton
                      key={`unit-${index}`}
                      selected={props.activeUnit === index}
                      onClick={() => props.setActiveUnit(index)}
                      sx={{
                        width: "auto",
                        minWidth: "auto",
                        px: 1.5,
                        py: 1,
                        minHeight: 40,
                        borderRadius: 0,
                        color: "#4f5062",
                        fontWeight: 500,
                        "&.Mui-selected": {
                          color: "#368cff",
                          fontWeight: 700,
                          bgcolor: "transparent",
                          borderBottom: "3px solid #368cff",
                        },
                        "&.Mui-selected:hover": { bgcolor: "transparent", color: "#368cff" },
                      }}
                    >
                      Unit {index + 1}
                    </ListItemButton>
                  ))
                ) : (
                  <ListItem sx={{ my: "0.25rem" }}>
                    <Box sx={{
                      flexGrow: 1,
                      minWidth: 0,
                      "& > b": { display: "block" },
                      "& > small": {
                        textTransform: "uppercase",
                        display: "block",
                        opacity: 0.3,
                        fontWeight: "bold",
                      },
                    }}>
                      <b>Gross Monthly Income</b>
                    </Box>
                  </ListItem>
                )}
              </List>
            </Grid>
            <Grid style={strategyIconGap20Style}>
              <Tooltip title="Total income generated from the property on a monthly basis">
                <Button
                  onClick={() =>
                    setOpenBuildToRentGrossMonthlyIncomeTour(true)
                  }
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
          <Divider />
          <CardContent>
            <Grid>
              <Grid>
                <Box sx={strategyFlexCenterOnlySx}>
                  <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                    <Chart
                      options={grossMonthlyIncomeChartOptions}
                      series={grossMonthlyIncomeChartSeries}
                      type="donut"
                      width="300"
                    />
                  </Suspense>
                </Box>
              </Grid>
              <Divider sx={strategyBlockSpacerSx} />
              <Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                  alignItems: "flex-start"
                  }}
                  spacing={1}
                  >
                  {map(grossMonthlyIncomeFields, (field) =>
                    renderInputFields(field),
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )},
    {
      name: 'expenses',
      card: (
        <Card variant="outlined" sx={{ width: "100%" }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Monthly Expenses</b>
            </Box>
            <div>
              <Tooltip title="Projected monthly expenditures and applicable costs associated with the property">
                <Button
                  onClick={() =>
                    setOpenBuildToRentMonthlyExpensesTour(true)
                  }
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Grid>
              <Grid>
                <Box sx={strategyFlexCenterOnlySx}>
                  <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                    <Chart
                      options={monthlyExpensesChartOptions}
                      series={monthlyExpensesChartSeries}
                      type="donut"
                      width="300"
                    />
                  </Suspense>
                </Box>
              </Grid>
              <Divider sx={strategyBlockSpacerSx} />
              <Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                  alignItems: "center"
                  }}
                  spacing={1}
                  >
                  {map(monthlyExpensesFields, (field) =>
                    renderInputFields(field),
                  )}
                </Grid>
              </Grid>
              <Grid>
                <Grid container direction="row" spacing={1}>
                  {!isEmpty(property.propertyManagementGroups) && (
                    <Grid size={12}>
                      <Button
                        fullWidth={true}
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={handleOpenManagementCompanies}
                      >
                        Property Management Companies
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )},
    {
      name: 'financing',
      card: (
        <Card variant="outlined" sx={{ width: "100%" }}>
          <Grid
            container
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              py: "0.75rem",
              px: "1.25rem",
              mb: 0,
              backgroundColor: "#fff",
              "html[data-color-mode=\"dark\"] &": { backgroundColor: "#1e1e1e !important", color: "rgba(255, 255, 255, 0.87)" },
            }}
            direction="row"
          >
            <Grid size={8} sx={{ minWidth: 0, overflowX: 'auto' }}>
              <List sx={[{ width: (analytics.B2R.mezzanineLoanAmount.length + 2) * 100, }, { display: "flex" }, {
                paddingTop: 0,
                paddingBottom: 0,
                "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root, & > .MuiListItem-root": {
                  color: "#a6a6b9",
                  position: "relative",
                  transition: "all 0.2s ease-in-out",
                  padding: "0.75rem 1.25rem 1rem",
                  background: "transparent",
                  width: "auto",
                  minHeight: 48,
                  margin: 0,
                  borderRadius: 0,
                  alignItems: "center",
                  alignSelf: "stretch",
                  boxSizing: "border-box",
                  "& .divider": {
                    width: "100%",
                    borderRadius: "0.75rem",
                    height: 3,
                    background: "#368cff",
                    visibility: "hidden",
                    opacity: 0,
                    transform: "translateY(-10px)",
                    transition: "all 0.2s ease-in-out",
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                  },
                  "&:hover": { color: "#000", background: "transparent" },
                  "&.Mui-selected": {
                    color: "#368cff",
                    background: "transparent",
                    "&:hover": { color: "#368cff" },
                    "& .divider": { visibility: "inherit", opacity: 1, transform: "translateY(0)" },
                    fontWeight: 700,
                  },
                },
                position: "relative",
                zIndex: 4,
                padding: 0,
                "&::after": {
                  background: "#f4f5fd",
                  height: 3,
                  borderRadius: "0.75rem",
                  display: "block",
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  content: "\"\"",
                  zIndex: 5,
                },
                "& .MuiListItem-root.MuiListItem-button + .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root + .MuiListItemButton-root": { marginLeft: "2rem" },
                "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": {
                  padding: "0.75rem 0 1rem",
                  margin: 0,
                  "& .divider": { zIndex: 8, left: 0, width: "100%" },
                },
              }]}>
                <ListItemButton
                  disableRipple
                  selected={activeTab === 0}
                  onClick={() => {
                    toggle(0)
                  }}
                >
                  <Typography
                    sx={{
                      flexGrow: 1,
                      minWidth: 0,
                      "& > b": { display: "block" },
                      "& > small": {
                        textTransform: "uppercase",
                        display: "block",
                        opacity: 0.3,
                        fontWeight: "bold",
                      },
                    }}
                    sx={strategyCenterTextSx}
                  >
                    Lot Loan
                  </Typography>
                  <Box sx={{ background: "#eeeff8", height: "1px", overflow: "hidden" }} />
                </ListItemButton>
                <ListItemButton
                  disableRipple
                  selected={activeTab === 1}
                  onClick={() => {
                    toggle(1)
                  }}
                >
                  <Typography
                    sx={{
                      flexGrow: 1,
                      minWidth: 0,
                      "& > b": { display: "block" },
                      "& > small": {
                        textTransform: "uppercase",
                        display: "block",
                        opacity: 0.3,
                        fontWeight: "bold",
                      },
                    }}
                    sx={strategyCenterTextSx}
                  >
                    Construction Loan
                  </Typography>
                  <Box sx={{ background: "#eeeff8", height: "1px", overflow: "hidden" }} />
                </ListItemButton>
                {map(
                  analytics.B2R.mezzanineLoanAmount,
                  (mezzanineLoanAmount, index) => (
                    <ListItemButton
                      key={`mezzanine-${index}`}
                      disableRipple
                      selected={activeTab === index + 2}
                      onClick={() => {
                        toggle(index + 2)
                      }}
                    >
                      <Typography
                        sx={{
                          flexGrow: 1,
                          minWidth: 0,
                          "& > b": { display: "block" },
                          "& > small": {
                            textTransform: "uppercase",
                            display: "block",
                            opacity: 0.3,
                            fontWeight: "bold",
                          },
                        }}
                        sx={strategyCenterTextSx}
                      >
                        Mezzanine Loan {index + 1}
                      </Typography>
                      <Box sx={{ background: "#eeeff8", height: "1px", overflow: "hidden" }} />
                    </ListItemButton>
                  ),
                )}
              </List>
            </Grid>
            <Grid>
              <IconButton
                onClick={props.createNewMezzanine}
                size="small"
              >
                <Add />
              </IconButton>
            </Grid>
            <Grid>
              <Tooltip title="Projected fund totals an investor will need to produce in order to acquire the property">
                <Button
                  onClick={() =>
                    activeTab > 1
                      ? setOpenBuildToRentMezzanineLoanTour(true)
                      : activeTab === 1
                        ? setOpenBuildToRentConstructionLoanTour(true)
                        : setOpenBuildToRentFinancingTour(true)
                  }
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                    mr: "1.5rem",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
          <Divider />
          <CardContent>
            {activeTab === 0 && (
              <>
                <Grid
                  container
                  sx={{
                    borderRadius: "0.65rem",
                    p: 1.5,
                    mb: 1,
                    bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
                    textAlign: "center",
                    border: "1px solid rgba(59, 62, 102, 0.1)",
                    "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      px: 1.25,
                      py: 0.75,
                      gap: 0.25,
                      boxSizing: "border-box",
                    },
                    "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
                    "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
                      minHeight: "2.6em",
                      lineHeight: 1.3,
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                      px: 0.5,
                      boxSizing: "border-box",
                    },
                    "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
                    "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
                      color: "#070919",
                      fontWeight: 700,
                      fontSize: "1.15rem",
                      lineHeight: 1.2,
                    },
                  }}
                >
                  <Grid
                    size={{ xs: 4 }}
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>Loan</Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          {/* <div>
                       fast
                     </div> */}
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={analytics.B2R.lotLoanAmount}
                              duration={1}
                              separator=","
                              decimals={0}
                              prefix="$"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    size={{ xs: 4 }}
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>
                        Mortgage/mo
                      </Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          {/* <div>
                       normal
                     </div> */}
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={analytics.B2R.lotMortgage}
                              duration={1}
                              delay={2}
                              separator=","
                              decimals={0}
                              prefix="$"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    size={{ xs: 4 }}
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>DSCR</Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          {/* <div>
                       slow
                     </div> */}
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={analytics.B2R.debtCoverageRatioLot}
                              duration={1}
                              delay={2}
                              separator=","
                              decimals={2}
                              suffix="x"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                </Grid>
                <Box component="p" sx={strategySubtitleCenterSx}>
                  Based on your{' '}
                  <b>
                    {currencyFormat.format(
                      analytics.B2R.allInCostB2R,
                    )}
                  </b>{' '}
                  <Tooltip title="The total amount of money this deal costs, including rehab, closing costs, points, etc.">
                    <Box component="span"
                      onClick={() => toggle1('All-in Cost')}
                      sx={strategyTooltipLinkSx}
                    >
                      all-in cost
                    </Box>
                  </Tooltip>
                  , you'll need to pay{' '}
                  <b>
                    {currencyFormat.format(
                      analytics.B2R.totalOutOfPocketB2R,
                    )}
                  </b>{' '}
                  <Tooltip title="Total amount that the buyer has to cover with their own money.">
                    <Box component="span"
                      onClick={() => toggle1('Total Out-of-Pocket')}
                      sx={strategyTooltipLinkSx}
                    >
                      out-of-pocket
                    </Box>
                  </Tooltip>{' '}
                  to cover the downpayment, closing costs, and rehab
                  for this property.
                </Box>
                <Divider
                  sx={strategyBlockSpacerSx}
                />
                <Grid container>
                  <Grid>
                    <Grid
                      container
                      direction="row"
                      sx={{
                      alignItems: "center"
                      }}
                      spacing={1}
                      >
                      {map(lotFinancingFields, (section) =>
                        renderInputFields(section),
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
            {activeTab === 1 && (
              <>
                <Grid
                  container
                  sx={{
                    borderRadius: "0.65rem",
                    p: 1.5,
                    mb: 1,
                    bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
                    textAlign: "center",
                    border: "1px solid rgba(59, 62, 102, 0.1)",
                    "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      px: 1.25,
                      py: 0.75,
                      gap: 0.25,
                      boxSizing: "border-box",
                    },
                    "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
                    "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
                      minHeight: "2.6em",
                      lineHeight: 1.3,
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                      px: 0.5,
                      boxSizing: "border-box",
                    },
                    "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
                    "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
                      color: "#070919",
                      fontWeight: 700,
                      fontSize: "1.15rem",
                      lineHeight: 1.2,
                    },
                  }}
                >
                  <Grid
                    size={{ xs: 4 }}
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>Loan</Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          {/* <Box sx={{
                            display: "inline-block",
                            py: 0,
                            px: "0.7em",
                            fontSize: "70%",
                            fontWeight: 700,
                            lineHeight: "21px",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            verticalAlign: "baseline",
                            borderRadius: "100%",
                            textTransform: "uppercase",
                            height: 10,
                            color: "#fff",
                            backgroundColor: "#1bc943",
                            textIndent: "-999rem",
                            width: 10,
                            p: 0,
                            boxShadow: "0 0 0 2px #fff",
                            mr: "0.5rem",
                          }}>
                       fast
                     </Box> */}
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={
                                analytics.B2R.constructionLoanAmount
                              }
                              duration={1}
                              separator=","
                              decimals={0}
                              prefix="$"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    size={{ xs: 4 }}
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>
                        Mortgage/mo
                      </Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          {/* <Box sx={{
                            display: "inline-block",
                            py: 0,
                            px: "0.7em",
                            fontSize: "70%",
                            fontWeight: 700,
                            lineHeight: "21px",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            verticalAlign: "baseline",
                            borderRadius: "100%",
                            textTransform: "uppercase",
                            height: 10,
                            color: "#fff",
                            backgroundColor: "#f4772e",
                            textIndent: "-999rem",
                            width: 10,
                            p: 0,
                            boxShadow: "0 0 0 2px #fff",
                            mr: "0.5rem",
                          }}>
                       normal
                     </Box> */}
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={analytics.B2R.constructionMortgage}
                              duration={1}
                              delay={2}
                              separator=","
                              decimals={0}
                              prefix="$"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    size={{ xs: 4 }}
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>DSCR</Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={
                                analytics.B2R
                                  .debtCoverageRatioConstruction
                              }
                              duration={1}
                              delay={2}
                              separator=","
                              decimals={2}
                              suffix="x"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                </Grid>
                <Box component="p" sx={strategySubtitleCenterSx}>
                  Based on your{' '}
                  <b>
                    {currencyFormat.format(
                      analytics.B2R.allInCostB2R,
                    )}
                  </b>{' '}
                  <Tooltip title="The total amount of money this deal costs, including rehab, closing costs, points, etc.">
                    <Box component="span"
                      onClick={() => toggle1('All-in Cost')}
                      sx={strategyTooltipLinkSx}
                    >
                      all-in cost
                    </Box>
                  </Tooltip>
                  , you'll need to pay{' '}
                  <b>
                    {currencyFormat.format(
                      analytics.B2R.totalOutOfPocketB2R,
                    )}
                  </b>{' '}
                  <Tooltip title="Total amount that the buyer has to cover with their own money.">
                    <Box component="span"
                      onClick={() => toggle1('Total Out-of-Pocket')}
                      sx={strategyTooltipLinkSx}
                    >
                      out-of-pocket
                    </Box>
                  </Tooltip>{' '}
                  to cover the downpayment, closing costs, and rehab
                  for this property.
                </Box>
                <Divider
                  sx={strategyBlockSpacerSx}
                />
                <Grid container>
                  <Grid>
                    <Grid
                      container
                      direction="row"
                      sx={{
                      alignItems: "center"
                      }}
                      spacing={1}
                      >
                      {map(constructionFinancingFields, (section) =>
                        renderInputFields(section),
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
            {activeTab >= 2 && (
              <>
                <Grid
                  container
                  sx={{
                    borderRadius: "0.65rem",
                    p: 1.5,
                    mb: 1,
                    bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
                    textAlign: "center",
                    border: "1px solid rgba(59, 62, 102, 0.1)",
                    "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      px: 1.25,
                      py: 0.75,
                      gap: 0.25,
                      boxSizing: "border-box",
                    },
                    "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
                    "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
                      minHeight: "2.6em",
                      lineHeight: 1.3,
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                      px: 0.5,
                      boxSizing: "border-box",
                    },
                    "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
                    "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
                      color: "#070919",
                      fontWeight: 700,
                      fontSize: "1.15rem",
                      lineHeight: 1.2,
                    },
                  }}
                >
                  <Grid
                    size={{ xs: 4 }}
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>Loan</Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          {/* <div>
                       fast
                     </div> */}
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={
                                analytics.B2R.mezzanineLoanAmount[
                                  activeTab - 2
                                ]
                              }
                              duration={1}
                              separator=","
                              decimals={0}
                              prefix="$"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    size={{ xs: 4 }}
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>
                        Mortgage/mo
                      </Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          {/* <div>
                       normal
                     </div> */}
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={
                                analytics.B2R.mezzanineMortgage[
                                  activeTab - 2
                                ]
                              }
                              duration={1}
                              delay={2}
                              separator=","
                              decimals={0}
                              prefix="$"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    size={{ xs: 4 }}
                    sx={[{ display: "flex" }, { justifyContent: "center" }]}
                  >
                    <div>
                      <Box sx={strategyFieldLabelSx}>DSCR</Box>
                      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                        <Box sx={strategyFlexPadSx}>
                          {/* <div>
                       slow
                     </div> */}
                          <Box component="span" sx={strategyBadgeIconSx}>
                            <CountUp
                              start={0}
                              end={
                                analytics.B2R
                                  .debtCoverageRatioMezzanine[
                                  activeTab - 2
                                ]
                              }
                              duration={1}
                              delay={2}
                              separator=","
                              decimals={2}
                              suffix="x"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                </Grid>
                <Box component="p" sx={strategySubtitleCenterSx}>
                  Based on your{' '}
                  <b>
                    {currencyFormat.format(
                      analytics.B2R.allInCostB2R,
                    )}
                  </b>{' '}
                  <Tooltip title="The total amount of money this deal costs, including rehab, closing costs, points, etc.">
                    <Box component="span"
                      onClick={() => toggle1('All-in Cost')}
                      sx={strategyTooltipLinkSx}
                    >
                      all-in cost
                    </Box>
                  </Tooltip>
                  , you'll need to pay{' '}
                  <b>
                    {currencyFormat.format(
                      analytics.B2R.totalOutOfPocketB2R,
                    )}
                  </b>{' '}
                  <Tooltip title="Total amount that the buyer has to cover with their own money.">
                    <Box component="span"
                      onClick={() => toggle1('Total Out-of-Pocket')}
                      sx={strategyTooltipLinkSx}
                    >
                      out-of-pocket
                    </Box>
                  </Tooltip>{' '}
                  to cover the downpayment, closing costs, and rehab
                  for this property.
                </Box>
                <Divider
                  sx={strategyBlockSpacerSx}
                />
                <Grid container>
                  <Grid>
                    <Grid
                      container
                      direction="row"
                      sx={{
                      alignItems: "center"
                      }}
                      spacing={1}
                      >
                      {map(
                        mezzanineFinancingFields(activeTab - 2),
                        (section) => renderInputFields(section),
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </CardContent>
        </Card>
      )},
    {
      name: 'endFinancing',
      card: (
        <Card variant="outlined" sx={{ width: "100%" }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>End Buyer Financing</b>
            </Box>
            <div>
              <Tooltip title="Projected fund totals an investor will need to produce in order to acquire the property">
                <Button
                  onClick={() =>
                    setOpenBuildToRentEndBuyerFinancingTour(true)
                  }
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Grid
              container
              sx={{
                borderRadius: "0.65rem",
                p: 1.5,
                mb: 1,
                bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
                textAlign: "center",
                border: "1px solid rgba(59, 62, 102, 0.1)",
                "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  px: 1.25,
                  py: 0.75,
                  gap: 0.25,
                  boxSizing: "border-box",
                },
                "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
                "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
                  minHeight: "2.6em",
                  lineHeight: 1.3,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  px: 0.5,
                  boxSizing: "border-box",
                },
                "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
                "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
                  color: "#070919",
                  fontWeight: 700,
                  fontSize: "1.15rem",
                  lineHeight: 1.2,
                },
              }}
            >
              <Grid size={{ xs: 4 }}
                sx={[{ display: "flex" }, { justifyContent: "center" }]}
              >
                <div>
                  <Box sx={strategyFieldLabelSx}>Loan</Box>
                  <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                    <Box sx={strategyFlexPadSx}>
                      {/* <Box sx={{
                        display: "inline-block",
                        py: 0,
                        px: "0.7em",
                        fontSize: "70%",
                        fontWeight: 700,
                        lineHeight: "21px",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        verticalAlign: "baseline",
                        borderRadius: "100%",
                        textTransform: "uppercase",
                        height: 10,
                        color: "#fff",
                        backgroundColor: "#1bc943",
                        textIndent: "-999rem",
                        width: 10,
                        p: 0,
                        boxShadow: "0 0 0 2px #fff",
                        mr: "0.5rem",
                      }}>
                        fast
                      </Box> */}
                      <Box component="span" sx={strategyBadgeIconSx}>
                        <CountUp
                          start={0}
                          end={analytics.turnkey.loanAmountTurnkey}
                          duration={1}
                          separator=","
                          decimals={0}
                          prefix="$"
                        />
                      </Box>
                    </Box>
                  </Box>
                </div>
              </Grid>
              <Grid size={{ xs: 4 }}
                sx={[{ display: "flex" }, { justifyContent: "center" }]}
              >
                <div>
                  <Box sx={strategyFieldLabelSx}>Mortgage/mo</Box>
                  <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                    <Box sx={strategyFlexPadSx}>
                      {/* <Box sx={{
                        display: "inline-block",
                        py: 0,
                        px: "0.7em",
                        fontSize: "70%",
                        fontWeight: 700,
                        lineHeight: "21px",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        verticalAlign: "baseline",
                        borderRadius: "100%",
                        textTransform: "uppercase",
                        height: 10,
                        color: "#fff",
                        backgroundColor: "#f4772e",
                        textIndent: "-999rem",
                        width: 10,
                        p: 0,
                        boxShadow: "0 0 0 2px #fff",
                        mr: "0.5rem",
                      }}>
                        normal
                      </Box> */}
                      <Box component="span" sx={strategyBadgeIconSx}>
                        <CountUp
                          start={0}
                          end={analytics.turnkey.mortgageTurnkey}
                          duration={1}
                          delay={2}
                          separator=","
                          decimals={0}
                          prefix="$"
                        />
                      </Box>
                    </Box>
                  </Box>
                </div>
              </Grid>
              <Grid size={{ xs: 4 }}
                sx={[{ display: "flex" }, { justifyContent: "center" }]}
              >
                <div>
                  <Box sx={strategyFieldLabelSx}>DSCR</Box>
                  <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                    <Box sx={strategyFlexPadSx}>
                      <Box component="span" sx={strategyBadgeIconSx}>
                        <CountUp
                          start={0}
                          end={
                            analytics.turnkey.debtCoverageRatioTurnkey
                          }
                          duration={1}
                          delay={2}
                          separator=","
                          decimals={2}
                          suffix="x"
                        />
                      </Box>
                    </Box>
                  </Box>
                </div>
              </Grid>
            </Grid>
            <Box component="p" sx={strategySubtitleCenterSx}>
              Based on your{' '}
              <b>
                {currencyFormat.format(
                  analytics.turnkey.allInCostTurnkey,
                )}
              </b>{' '}
              <Tooltip title="The total amount of money this deal costs, including rehab, closing costs, points, etc.">
                <Box component="span"
                  onClick={() => toggle1('All-in Cost End Buyer')}
                  sx={strategyTooltipLinkSx}
                >
                  all-in cost
                </Box>
              </Tooltip>
              , you'll need to pay{' '}
              <b>
                {currencyFormat.format(
                  analytics.turnkey.totalOutOfPocketTurnkey,
                )}
              </b>{' '}
              <Tooltip title="Total amount that the buyer has to cover with their own money.">
                <Box component="span"
                  onClick={() =>
                    toggle1('Total Out-of-Pocket End Buyer')
                  }
                  sx={strategyTooltipLinkSx}
                >
                  out-of-pocket
                </Box>
              </Tooltip>{' '}
              to cover the downpayment, closing costs, and rehab for
              this property.
            </Box>
            <Divider sx={strategyBlockSpacerSx} />
            <Grid container>
              <Grid>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  sx={{
                    alignItems: "center"
                  }}
                >
                  {map(financingFields, (section) =>
                    renderInputFields(section),
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )},
    {
      name: 'projection',
      card: (
        <Card variant="outlined" sx={{ width: "100%" }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Value Over Time</b>
            </Box>
            <div>
              <Tooltip title="Projected paydown timelines and cashflow options available on this property">
                <Button
                  onClick={() =>
                    setOpenBuildToRentValueOverTimeTour(true)
                  }
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Box sx={{
              borderRadius: "0.65rem",
              p: 1.5,
              mb: 1,
              bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
              textAlign: "center",
              border: "1px solid rgba(59, 62, 102, 0.1)",
              "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                px: 1.25,
                py: 0.75,
                gap: 0.25,
                boxSizing: "border-box",
              },
              "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
              "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
                minHeight: "2.6em",
                lineHeight: 1.3,
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                px: 0.5,
                boxSizing: "border-box",
              },
              "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
              "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
                color: "#070919",
                fontWeight: 700,
                fontSize: "1.15rem",
                lineHeight: 1.2,
              },
            }}>
              <Grid container sx={{ color: "rgba(59, 62, 102, 0.5)" }}>
                <Grid size={{ xs: 4 }}
                  sx={[{ display: "flex" }, { justifyContent: "center" }]}
                >
                  <div data-tour="valueOverTime-step-1">
                    <Box sx={strategyFieldLabelSx}>
                      Property Paid off
                    </Box>
                    <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                      <Box sx={strategyFlexPadSx}>
                        {/* <div>
                         fast
                       </div> */}
                        <Box component="span" sx={strategyBadgeIconSx}>
                          <CountUp
                            start={0}
                            end={
                              analytics.turnkey
                                .propertyPayOffYearsTurnkey
                            }
                            duration={1}
                            separator=","
                            decimals={1}
                            suffix=" yrs"
                          />
                        </Box>
                      </Box>
                    </Box>
                  </div>
                </Grid>
                <Grid size={{ xs: 4 }}
                  sx={[{ display: "flex" }, { justifyContent: "center" }]}
                >
                  <div data-tour="valueOverTime-step-2">
                    <Box sx={strategyFieldLabelSx}>
                      Value at payoff
                    </Box>
                    <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                      <Box sx={strategyFlexPadSx}>
                        {/* <div>
                         fast
                       </div> */}
                        <Box component="span" sx={strategyBadgeIconSx}>
                          <CountUp
                            start={0}
                            end={
                              analytics.turnkey
                                .propertyAppreciationValueTurnkey
                            }
                            duration={1}
                            separator=","
                            decimals={0}
                            prefix="$"
                          />
                        </Box>
                      </Box>
                    </Box>
                  </div>
                </Grid>
                <Grid size={{ xs: 4 }}
                  sx={[{ display: "flex" }, { justifyContent: "center" }]}
                >
                  <div data-tour="valueOverTime-step-3">
                    <Box sx={strategyFieldLabelSx}>
                      Cashflow at payoff
                    </Box>
                    <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
                      <Box sx={strategyFlexPadSx}>
                        {/* <div>
                         normal
                       </div> */}
                        <Box component="span" sx={strategyBadgeIconSx}>
                          <CountUp
                            start={0}
                            end={
                              analytics.turnkey
                                .cashFlowAtPayoffTurnkey
                            }
                            duration={1}
                            delay={2}
                            separator=","
                            decimals={0}
                            prefix="$"
                          />
                        </Box>
                      </Box>
                    </Box>
                  </div>
                </Grid>
              </Grid>
            </Box>
            {analytics.B2R.cashFlowB2R >= 0 ? (
              <Box component="p"
               
                data-tour="valueOverTime-step-4" sx={strategySubtitleCenterSx}>
                If you took{' '}
                <b>
                  {currencyFormat.format(
                    ((analytics.B2R.cashFlowB2R / 12) *
                      analytics.payDownAccelerator) /
                      100,
                  )}
                </b>{' '}
                ({analytics.payDownAccelerator}% of the net cashflow)
                and paid it towards the{' '}
                <Tooltip title="The amount you borrowed from the lender.">
                  <Box component="span"
                    sx={strategyTooltipLinkSx}
                  >
                    loan principal
                  </Box>
                </Tooltip>{' '}
                each month, this property could be paid off in{' '}
                <b>
                  {analytics.turnkey.propertyPayOffYearsTurnkey
                    ? analytics.turnkey.propertyPayOffYearsTurnkey.toFixed(
                        1,
                      )
                    : '-'}{' '}
                  years
                </b>
                {analytics.turnkey.propertyPayOffYearsTurnkey
                  ? analytics.turnkey.propertyPayOffYearsTurnkey.toFixed(
                      1,
                    ) ===
                    (assumptions.termTurnkey === 'Years'
                      ? assumptions.termTurnkey
                      : assumptions.termTurnkey / 12
                    ).toFixed(1)
                    ? ''
                    : ` instead of ${
                        assumptions.termTurnkey
                          ? (assumptions.termTurnkey === 'Years'
                              ? assumptions.termTurnkey
                              : assumptions.termTurnkey / 12
                            ).toFixed(1)
                          : 0
                      }`
                  : ''}
                .
              </Box>
            ) : (
              <Box component="p"
               
                data-tour="valueOverTime-step-4" sx={strategySubtitleCenterSx}>
                The cashflow of this property is less than zero, which
                means you can't take a percent of the cashflow and pay
                it towards the loan balance.
              </Box>
            )}
            <Divider sx={strategyBlockSpacerSx} />
            <Grid container>
              <Grid>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  sx={{
                    alignItems: "center"
                  }}
                >
                  {map(projectionAssumptionsFields, (section) =>
                    renderInputFields(section),
                  )}
                  {/* <Grid size={12}>
                     <Typography id="continuous-slider" gutterBottom>
                       Paydown Accelerator (% of net cashflow)
                     </Typography>
                     <Slider value={75} />
                     <Grid container direction='row' justifyContent='space-between'>
                       <Grid>
                         <Typography id="continuous-slider" gutterBottom>
                           0%
                         </Typography>
                       </Grid>
                       <Grid>
                         <Typography>100%</Typography>
                       </Grid>
                     </Grid>
                   </Grid> */}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )},
    {
      name: 'cashPositioning',
      card: (
        <Card variant="outlined" sx={{ width: "100%" }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Cash Positioning</b>
            </Box>
            <div>
              <Tooltip title="Projected cash growth over one, three, five, and ten years">
                <Button
                  onClick={() =>
                    setOpenBuildToRentCashPositioningTour(true)
                  }
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Suspense fallback={<LoadingSkeleton variant="chart" />}>
              <Chart options={options} series={series} type="bar" />
            </Suspense>
            <Tooltip
              title={`Total Return of ${assumptions.rentalHoldingPeriodB2R} years`}
            >
              <Box
                sx={{
                  borderRadius: "0.65rem",
                  p: 1.5,
                  mb: 1,
                  bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
                  textAlign: "center",
                  border: "1px solid rgba(59, 62, 102, 0.1)",
                  "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    px: 1.25,
                    py: 0.75,
                    gap: 0.25,
                    boxSizing: "border-box",
                  },
                  "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
                  "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
                    minHeight: "2.6em",
                    lineHeight: 1.3,
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    px: 0.5,
                    boxSizing: "border-box",
                  },
                  "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
                  "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
                    color: "#070919",
                    fontWeight: 700,
                    fontSize: "1.15rem",
                    lineHeight: 1.2,
                  },
                }}
                onClick={() => toggle1('Total Return')}
              >
                <Grid container sx={{
                  justifyContent: "space-around"
                }}>
                  <Grid data-tour="cashPositioning-step-1">
                    <Typography>Total Return</Typography>
                    <Typography>
                      {currencyFormat.format(
                        analytics.B2R.totalReturnOnInvestmentB2R,
                      )}
                    </Typography>
                  </Grid>
                  <Grid data-tour="cashPositioning-step-2">
                    <Typography>Total Return %</Typography>
                    <Typography>
                      {percentageFormat.format(
                        analytics.B2R.totalOutOfPocketB2R
                          ? analytics.B2R.totalReturnOnInvestmentB2R /
                              analytics.B2R.totalOutOfPocketB2R
                          : 0,
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Tooltip>
            {/* <Grid container direction="row">
              <Grid size={12}>
                <Button
                  variant='outlined'
                  fullWidth
                  onClick={handleOpenAmortization}
                >
                  <Typography>Amortization</Typography>
                </Button>
              </Grid>
            </Grid> */}
          </CardContent>
        </Card>
      )},
    {
      name: 'comparableProperties',
      card: (
        <ComparablePropertiesCard
          basicView={props.basicView}
          compData={compData}
          onComparablePropertiesTourClick={
            toggleComparablePropertiesTour
          }
          onToggleCenter={props.toggleCenter}
          determinedComps={props.determinedComps}
          compProperties={props.compProperties}
        />
      )},
    {
      name: 'disposition',
      card: (
        <Card variant="outlined" sx={{ width: "100%" }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Disposition Expenses</b>
            </Box>
            <div>
              <Tooltip title="All costs and expenses associated with sale of this property">
                <Button
                  onClick={() =>
                    setOpenBuildToRentDispositionExpensesTour(true)
                  }
                  sx={{
                    backgroundColor: "rgba(54, 140, 255, 0.15)",
                    color: "#368cff",
                    borderColor: "transparent",
                    "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
                    "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
                    height: "30px !important",
                    width: "30px !important",
                    lineHeight: "30px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    border: 0,
                    textAlign: "left",
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'info-circle']} />
                </Button>
              </Tooltip>
            </div>
          </Box>
          <Divider />
          <CardContent>
            <Grid>
              <Grid>
                <Box sx={strategyFlexCenterOnlySx}>
                  <Suspense fallback={<LoadingSkeleton variant="chart" />}>
                    <Chart
                      options={dispositionChartOptions}
                      series={dispositionChartSeries}
                      type="donut"
                      width="300"
                    />
                  </Suspense>
                </Box>
              </Grid>
              <Divider sx={strategyBlockSpacerSx} />
              <Grid>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  sx={{
                    alignItems: "center"
                  }}
                >
                  {map(dispositionFields, (field) =>
                    renderInputFields(field),
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )},
    {
      name: 'deactive',
      card: <DeactiveCard />},
  ]

  const [updateProperty] = useMutation(UPDATE_PROPERTY)
  const [updateOrganization] = useMutation(UPDATE_ORGANIZATION)

  return (
    <>
      <StrategyPageBase
        cards={buildToRentCards}
        strategyName="Build to Rent"
        strategyKey="buildToRent"
        property={property}
        activeOrg={activeOrg}
        canDrag={props.canDrag}
        publicDashboard={props.publicDashboard}
        publicImageCard={props.publicImageCard}
        session={props.session}
        renderInputFields={renderInputFields}
      />
      {map(financials, (section) => (
        <Dialog
          key={section.label}
          open={modal1 === section.label}
          onClose={toggle1Close}
          maxWidth="lg"
          scroll="body"
          slotProps={{ paper: { sx: calcDialogPaperSx } }}
        >
          {/* <BlockUi blocking={loader} loader={<PacmanLoader color={'var(--primary)'} loading={true} />}> */}
          <Grid container spacing={0}>
            <Grid size={5}>
              <Box sx={[strategyFullHeight100Sx, {
                position: "relative",
                display: "flex",
                flexDirection: "column",
                "& > .divider": { zIndex: 7, width: "100%" },
                "& .hero-footer": { zIndex: 7 },
                "& .header-nav-wrapper": { zIndex: 27 },
                "& .bg-composed-wrapper--image": { backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center" },
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
                alignItems: "center",
                ".MuiCard-root > &": {
                  top: -1,
                  marginLeft: -1,
                  marginRight: -1,
                  marginBottom: -2,
                  zIndex: 6,
                },
                backgroundImage: "linear-gradient(135deg, var(--hf-calc-hero-from, #CE9FFC) 10%, var(--hf-calc-hero-to, #7367F0) 100%) !important",
                  "html[data-color-mode=\"dark\"] & .MuiTypography-root": { color: "rgba(255, 255, 255, 0.92) !important" },
              }, {
                borderRadius: "0.65rem !important",
                "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
              }]}>
                <Box sx={[strategyFlexCenterRowSx, strategyFlexGrowSx]}>
                  <Box sx={[strategyNavyBgSx, {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    height: "100%",
                    width: "100%",
                    zIndex: 5,
                    opacity: "0.7 !important",
                  }, {
                    borderRadius: "0.65rem !important",
                    "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
                  }]} />
                  <Box sx={[{
                    justifyContent: "center",
                    "@media (min-width: 1440px)": { justifyContent: "flex-start", textAlign: "left" },
                    textAlign: "center",
                    p: "3rem",
                  }, { position: "relative", zIndex: "7", width: "100%" }]}>
                    <Box sx={strategyFooterNoteSx}>
                      <Typography sx={strategyCardTitleSx}>
                        Calculation
                      </Typography>
                    </Box>
                    {section.calculation}
                    <Box sx={strategyFooterNoteSx}>
                      <Typography>
                        * Calculation may be a few dollars off due to
                        rounding
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid size={7}>
              <div>
                <Card>
                  <CardHeader title={section.label} />
                  <Divider />
                  <CardContent sx={strategyFullHeight100Sx}>
                    <Grid
                      container
                      direction="row"
                      sx={{
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                      <Grid size={12} sx={strategyMarginBottom10Sx}>
                        <Card sx={strategyMetricGrayBgSx}>
                          <CardContent>
                            <Typography>
                              {section.description}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Divider />
                  <CardActions>
                    <Grid container sx={{
                      justifyContent: "center"
                    }}>
                      <Grid>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={toggle1Close}
                        >
                          Close
                        </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </div>
            </Grid>
          </Grid>
          {/* </BlockUi> */}
        </Dialog>
      ))}

      <Dialog
        open={openManagementCompanies}
        onClose={handleCloseManagementCompanies}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle>Property Management Companies</DialogTitle>
        <DialogContent sx={strategyPadVert15Sx}>
          <Grid container direction="column" spacing={2}>
            {map(
              filter(propertyManagementCompanies, (company) =>
                includes(
                  property.propertyManagementGroups,
                  company.value,
                ),
              ),
              (section) => (
                <Grid>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    sx={{
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}>
                    <Grid>
                      <Box data-hf="avatar-image" sx={[strategyCircleGreenAvatarSx, {
                        borderRadius: "0.65rem !important",
                        "& .blur-load": { backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" },
                      }]}>
                        <Box component="img" src={section.image} alt="..." sx={{
                          maxWidth: "100%",
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                          objectPosition: "center",
                          borderRadius: "0.29rem !important",
                        }} />
                      </Box>{' '}
                    </Grid>
                    <Grid>
                      <Typography>{section.name}</Typography>
                    </Grid>
                    <Grid>
                      <Typography>{section.url}</Typography>
                    </Grid>
                    <Grid>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        href={section.link}
                        target="_blank"
                      >
                        <Typography>View</Typography>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              ),
            )}
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        open={modal1 === 'Total Return'}
        onClose={toggle1Close}
        maxWidth="lg"
        scroll="body"
        slotProps={{ paper: { sx: calcDialogPaperSx } }}
      >
        <Grid container spacing={0}>
          <Grid size={5}>
            <Box sx={[strategyFullHeight100Sx, {
              position: "relative",
              display: "flex",
              flexDirection: "column",
              "& > .divider": { zIndex: 7, width: "100%" },
              "& .hero-footer": { zIndex: 7 },
              "& .header-nav-wrapper": { zIndex: 27 },
              "& .bg-composed-wrapper--image": { backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center" },
              borderTopLeftRadius: "inherit",
              borderTopRightRadius: "inherit",
              alignItems: "center",
              ".MuiCard-root > &": {
                top: -1,
                marginLeft: -1,
                marginRight: -1,
                marginBottom: -2,
                zIndex: 6,
              },
              backgroundImage: "linear-gradient(135deg, var(--hf-calc-hero-from, #CE9FFC) 10%, var(--hf-calc-hero-to, #7367F0) 100%) !important",
                  "html[data-color-mode=\"dark\"] & .MuiTypography-root": { color: "rgba(255, 255, 255, 0.92) !important" },
            }, {
              borderRadius: "0.65rem !important",
              "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
            }]}>
              <Box sx={[strategyFlexCenterRowSx, strategyFlexGrowSx]}>
                <Box sx={[strategyNavyBgSx, {
                  position: "absolute",
                  left: 0,
                  top: 0,
                  height: "100%",
                  width: "100%",
                  zIndex: 5,
                  opacity: "0.7 !important",
                }, {
                  borderRadius: "0.65rem !important",
                  "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
                }]} />
                <Box sx={[{
                  justifyContent: "center",
                  "@media (min-width: 1440px)": { justifyContent: "flex-start", textAlign: "left" },
                  textAlign: "center",
                  p: "3rem",
                }, { position: "relative", zIndex: "7", width: "100%" }]}>
                  <Box sx={strategyFooterNoteSx}>
                    <Typography sx={strategyCardTitleSx}>
                      Calculation
                    </Typography>
                  </Box>
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        Cash flow
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        {currencyFormat.format(
                          round(analytics.B2R.cashFlowB2R, 0),
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        +Principal Reduction
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        +
                        {currencyFormat.format(
                          round(
                            analytics.B2R.lotPrincipalReduction +
                              analytics.B2R
                                .constructionPrincipalReduction +
                              sum(
                                analytics.B2R
                                  .mezzaninePrincipalReduction,
                              ),
                          ),
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        +Anticipated Annual Appreciation
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        +
                        {currencyFormat.format(
                          round(
                            analytics.B2R
                              .anticipatedAnnualAppreciationB2R,
                            0,
                          ),
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={strategyMutedDividerSx} />
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyWhiteTextSx}>
                        Total Return
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyWhiteTextSx}>
                        {currencyFormat.format(
                          round(
                            analytics.B2R.totalReturnOnInvestmentB2R,
                            0,
                          ),
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        <FontAwesomeIcon
                          icon={['fal', 'divide']}
                          style={strategyIconGapStyle}
                        />
                        Total Out Of Pocket
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        <FontAwesomeIcon
                          icon={['fal', 'divide']}
                          style={strategyIconGapStyle}
                        />
                        {currencyFormat.format(
                          round(analytics.B2R.totalOutOfPocketB2R, 0),
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={strategyMutedDividerSx} />
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyWhiteTextSx}>
                        Total Return %
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyWhiteTextSx}>
                        {percentageFormat.format(
                          analytics.B2R.totalOutOfPocketB2R
                            ? analytics.B2R
                                .totalReturnOnInvestmentB2R /
                                analytics.B2R.totalOutOfPocketB2R
                            : 0,
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Box sx={strategyFooterNoteSx}>
                    <Typography>
                      * Calculation may be a few dollars off due to
                      rounding
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={7}>
            <div>
              <Card>
                <CardHeader title="Total Return" />
                <Divider />
                <CardContent sx={strategyFullHeight100Sx}>
                  <Grid
                    container
                    direction="row"
                    sx={{
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                    <Grid size={12} sx={strategyMarginBottom10Sx}>
                      <Card sx={strategyMetricGrayBgSx}>
                        <CardContent>
                          <Typography>
                            The actual rate of return of an investment
                            over a given evaluation period which
                            includes income and appreciation.
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </CardContent>
                <Divider />
                <CardActions>
                  <Grid container sx={{
                    justifyContent: "center"
                  }}>
                    <Grid>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={toggle1Close}
                      >
                        Close
                      </Button>
                    </Grid>
                  </Grid>
                </CardActions>
              </Card>
            </div>
          </Grid>
        </Grid>
      </Dialog>

      <AmortizationDialog
        open={openAmortization}
        onClose={handleCloseAmortization}
        tableHeaders={tableHeaders}
        amortizationData={amortizationData}
        currencyFormat2={currencyFormat2}
        assumptions={assumptions}
      />

      <Dialog
        open={openConfirmLender}
        onClose={toggleOpenConfirmLender}
      >
        <DialogTitle>Disclaimer</DialogTitle>
        <DialogContent>
          Would you like to overwrite the Down Payment, Interest Rate,
          Financing Term, and Points values with the values from the
          selected lender?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              toggleOpenConfirmLender()
            }}
          >
            No
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={(event) => {
              toggleOpenConfirmLender()
              props.lenderOverride(activeTab)
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <BuildToRentStrategyTour
        isOpenBuildToRentStrategyTour={openStrategyTour}
        closeBuildToRentStrategyTour={closeStrategyTour}
      />
      <BuildToRentTargetsTour
        isOpenBuildToRentTargetsTour={openTargetsTour}
        closeBuildToRentTargetsTour={closeTargetsTour}
      />
      <BuildToRentMonthlyCashflowTour
        isOpenBuildToRentMonthlyCashflowTour={
          openBuildToRentMonthlyCashflowTour
        }
        closeBuildToRentMonthlyCashflowTour={() =>
          setOpenBuildToRentMonthlyCashflowTour(false)
        }
      />
      <BuildToRentGrossMonthlyIncomeTour
        isOpenBuildToRentGrossMonthlyIncomeTour={
          openBuildToRentGrossMonthlyIncomeTour
        }
        closeBuildToRentGrossMonthlyIncomeTour={() =>
          setOpenBuildToRentGrossMonthlyIncomeTour(false)
        }
      />
      <BuildToRentMonthlyExpensesTour
        isOpenBuildToRentMonthlyExpensesTour={
          openBuildToRentMonthlyExpensesTour
        }
        closeBuildToRentMonthlyExpensesTour={() =>
          setOpenBuildToRentMonthlyExpensesTour(false)
        }
      />
      <BuildToRentFinancingTour
        isOpenBuildToRentFinancingTour={openBuildToRentFinancingTour}
        closeBuildToRentFinancingTour={() =>
          setOpenBuildToRentFinancingTour(false)
        }
      />
      <BuildToRentConstructionLoanTour
        isOpenBuildToRentConstructionLoanTour={
          openBuildToRentConstructionLoanTour
        }
        closeBuildToRentConstructionLoanTour={() =>
          setOpenBuildToRentConstructionLoanTour(false)
        }
      />
      <BuildToRentMezzanineLoanTour
        isOpenBuildToRentMezzanineLoanTour={
          openBuildToRentMezzanineLoanTour
        }
        closeBuildToRentMezzanineLoanTour={() =>
          setOpenBuildToRentMezzanineLoanTour(false)
        }
      />
      <BuildToRentEndBuyerFinancingTour
        isOpenBuildToRentEndBuyerFinancingTour={
          openBuildToRentEndBuyerFinancingTour
        }
        closeBuildToRentEndBuyerFinancingTour={() =>
          setOpenBuildToRentEndBuyerFinancingTour(false)
        }
      />
      <BuildToRentValueOverTimeTour
        isOpenBuildToRentValueOverTimeTour={
          openBuildToRentValueOverTimeTour
        }
        closeBuildToRentValueOverTimeTour={() =>
          setOpenBuildToRentValueOverTimeTour(false)
        }
      />
      <BuildToRentCashPositioningTour
        isOpenBuildToRentCashPositioningTour={
          openBuildToRentCashPositioningTour
        }
        closeBuildToRentCashPositioningTour={() =>
          setOpenBuildToRentCashPositioningTour(false)
        }
      />
      <BuildToRentDispositionExpensesTour
        isOpenBuildToRentDispositionExpensesTour={
          openBuildToRentDispositionExpensesTour
        }
        closeBuildToRentDispositionExpensesTour={() =>
          setOpenBuildToRentDispositionExpensesTour(false)
        }
      />
      <BuildToRentComparablePropertiesTour
        isOpenBuildToRentComparablePropertiesTour={openComparablePropertiesTour}
        closeBuildToRentComparablePropertiesTour={closeComparablePropertiesTour}
      />
    </>
  );
}

export default withSession(CenterPageBuildToRent)
